export const counties = [
    "Abbeville County, South Carolina",
    "Acadia Parish, Louisiana",
    "Accomack County, Virginia",
    "Ada County, Idaho",
    "Adair County, Iowa",
    "Adair County, Kentucky",
    "Adair County, Missouri",
    "Adair County, Oklahoma",
    "Adams County, Colorado",
    "Adams County, Idaho",
    "Adams County, Illinois",
    "Adams County, Indiana",
    "Adams County, Iowa",
    "Adams County, Mississippi",
    "Adams County, Nebraska",
    "Adams County, North Dakota",
    "Adams County, Ohio",
    "Adams County, Pennsylvania",
    "Adams County, Washington",
    "Adams County, Wisconsin",
    "Addison County, Vermont",
    "Aiken County, South Carolina",
    "Aitkin County, Minnesota",
    "Alachua County, Florida",
    "Alamance County, North Carolina",
    "Alameda County, California",
    "Alamosa County, Colorado",
    "Albany County, New York",
    "Albany County, Wyoming",
    "Albemarle County, Virginia",
    "Alcona County, Michigan",
    "Alcorn County, Mississippi",
    "Alexander County, Illinois",
    "Alexander County, North Carolina",
    "Alfalfa County, Oklahoma",
    "Alger County, Michigan",
    "Allamakee County, Iowa",
    "Allegan County, Michigan",
    "Allegany County, Maryland",
    "Allegany County, New York",
    "Alleghany County, North Carolina",
    "Alleghany County, Virginia",
    "Allegheny County, Pennsylvania",
    "Allen County, Indiana",
    "Allen County, Kansas",
    "Allen County, Kentucky",
    "Allen Parish, Louisiana",
    "Allen County, Ohio",
    "Allendale County, South Carolina",
    "Alpena County, Michigan",
    "Alpine County, California",
    "Amador County, California",
    "Amelia County, Virginia",
    "Amherst County, Virginia",
    "Amite County, Mississippi",
    "Anderson County, Kansas",
    "Anderson County, Kentucky",
    "Anderson County, South Carolina",
    "Anderson County, Tennessee",
    "Anderson County, Texas",
    "Andrew County, Missouri",
    "Andrews County, Texas",
    "Androscoggin County, Maine",
    "Angelina County, Texas",
    "Anne Arundel County, Maryland",
    "Anoka County, Minnesota",
    "Anson County, North Carolina",
    "Antelope County, Nebraska",
    "Antrim County, Michigan",
    "Apache County, Arizona",
    "Appanoose County, Iowa",
    "Appling County, Georgia",
    "Appomattox County, Virginia",
    "Aransas County, Texas",
    "Arapahoe County, Colorado",
    "Archer County, Texas",
    "Archuleta County, Colorado",
    "Arenac County, Michigan",
    "Arkansas County, Arkansas",
    "Arlington County, Virginia",
    "Armstrong County, Texas",
    "Aroostook County, Maine",
    "Arthur County, Nebraska",
    "Ascension Parish, Louisiana",
    "Ashe County, North Carolina",
    "Ashland County, Ohio",
    "Ashland County, Wisconsin",
    "Ashley County, Arkansas",
    "Ashtabula County, Ohio",
    "Asotin County, Washington",
    "Assumption Parish, Louisiana",
    "Atascosa County, Texas",
    "Atchison County, Kansas",
    "Atchison County, Missouri",
    "Athens County, Ohio",
    "Atkinson County, Georgia",
    "Atlantic County, New Jersey",
    "Atoka County, Oklahoma",
    "Attala County, Mississippi",
    "Audrain County, Missouri",
    "Audubon County, Iowa",
    "Auglaize County, Ohio",
    "Augusta County, Virginia",
    "Aurora County, South Dakota",
    "Austin County, Texas",
    "Autauga County, Alabama",
    "Avery County, North Carolina",
    "Avoyelles Parish, Louisiana",
    "Baca County, Colorado",
    "Bacon County, Georgia",
    "Bailey County, Texas",
    "Baker County, Florida",
    "Baker County, Georgia",
    "Baker County, Oregon",
    "Baldwin County, Alabama",
    "Baldwin County, Georgia",
    "Ballard County, Kentucky",
    "Baltimore County, Maryland",
    "Bamberg County, South Carolina",
    "Bandera County, Texas",
    "Banks County, Georgia",
    "Bannock County, Idaho",
    "Baraga County, Michigan",
    "Barber County, Kansas",
    "Barbour County, Alabama",
    "Barbour County, West Virginia",
    "Barnes County, North Dakota",
    "Barnwell County, South Carolina",
    "Barren County, Kentucky",
    "Barron County, Wisconsin",
    "Barrow County, Georgia",
    "Barry County, Michigan",
    "Barry County, Missouri",
    "Bartholomew County, Indiana",
    "Barton County, Kansas",
    "Barton County, Missouri",
    "Bartow County, Georgia",
    "Bastrop County, Texas",
    "Bates County, Missouri",
    "Bath County, Kentucky",
    "Bath County, Virginia",
    "Baxter County, Arkansas",
    "Bay County, Florida",
    "Bay County, Michigan",
    "Bayfield County, Wisconsin",
    "Baylor County, Texas",
    "Beadle County, South Dakota",
    "Bear Lake County, Idaho",
    "Beaufort County, North Carolina",
    "Beaufort County, South Carolina",
    "Beauregard Parish, Louisiana",
    "Beaver County, Oklahoma",
    "Beaver County, Pennsylvania",
    "Beaver County, Utah",
    "Beaverhead County, Montana",
    "Becker County, Minnesota",
    "Beckham County, Oklahoma",
    "Bedford County, Pennsylvania",
    "Bedford County, Tennessee",
    "Bedford County, Virginia",
    "Bee County, Texas",
    "Belknap County, New Hampshire",
    "Bell County, Kentucky",
    "Bell County, Texas",
    "Belmont County, Ohio",
    "Beltrami County, Minnesota",
    "Ben Hill County, Georgia",
    "Benewah County, Idaho",
    "Bennett County, South Dakota",
    "Bennington County, Vermont",
    "Benson County, North Dakota",
    "Bent County, Colorado",
    "Benton County, Arkansas",
    "Benton County, Iowa",
    "Benton County, Minnesota",
    "Benton County, Missouri",
    "Benton County, Oregon",
    "Benton County, Tennessee",
    "Benton County, Washington",
    "Benzie County, Michigan",
    "Bergen County, New Jersey",
    "Berkeley County, South Carolina",
    "Berkeley County, West Virginia",
    "Berks County, Pennsylvania",
    "Bernalillo County, New Mexico",
    "Berrien County, Georgia",
    "Berrien County, Michigan",
    "Bertie County, North Carolina",
    "Bexar County, Texas",
    "Bibb County, Alabama",
    "Bibb County, Georgia",
    "Bienville Parish, Louisiana",
    "Big Horn County, Montana",
    "Big Horn County, Wyoming",
    "Big Stone County, Minnesota",
    "Billings County, North Dakota",
    "Bingham County, Idaho",
    "Black Hawk County, Iowa",
    "Blackford County, Indiana",
    "Bladen County, North Carolina",
    "Blaine County, Idaho",
    "Blaine County, Montana",
    "Blaine County, Oklahoma",
    "Blair County, Pennsylvania",
    "Blanco County, Texas",
    "Bland County, Virginia",
    "Bleckley County, Georgia",
    "Bledsoe County, Tennessee",
    "Blount County, Alabama",
    "Blount County, Tennessee",
    "Blue Earth County, Minnesota",
    "Boise County, Idaho",
    "Bolivar County, Mississippi",
    "Bollinger County, Missouri",
    "Bon Homme County, South Dakota",
    "Bond County, Illinois",
    "Bonner County, Idaho",
    "Bonneville County, Idaho",
    "Boone County, Arkansas",
    "Boone County, Illinois",
    "Boone County, Indiana",
    "Boone County, Iowa",
    "Boone County, Kentucky",
    "Boone County, Missouri",
    "Boone County, Nebraska",
    "Boone County, West Virginia",
    "Borden County, Texas",
    "Bosque County, Texas",
    "Bossier Parish, Louisiana",
    "Botetourt County, Virginia",
    "Bottineau County, North Dakota",
    "Boulder County, Colorado",
    "Boundary County, Idaho",
    "Bourbon County, Kansas",
    "Bourbon County, Kentucky",
    "Bowie County, Texas",
    "Bowman County, North Dakota",
    "Box Butte County, Nebraska",
    "Box Elder County, Utah",
    "Boyd County, Kentucky",
    "Boyd County, Nebraska",
    "Boyle County, Kentucky",
    "Bracken County, Kentucky",
    "Bradford County, Florida",
    "Bradford County, Pennsylvania",
    "Bradley County, Arkansas",
    "Bradley County, Tennessee",
    "Branch County, Michigan",
    "Brantley County, Georgia",
    "Braxton County, West Virginia",
    "Brazoria County, Texas",
    "Brazos County, Texas",
    "Breathitt County, Kentucky",
    "Breckinridge County, Kentucky",
    "Bremer County, Iowa",
    "Brevard County, Florida",
    "Brewster County, Texas",
    "Briscoe County, Texas",
    "Bristol Bay Borough, Alaska",
    "Broadwater County, Montana",
    "Brooke County, West Virginia",
    "Brookings County, South Dakota",
    "Brooks County, Georgia",
    "Brooks County, Texas",
    "Broome County, New York",
    "Broomfield County, Colorado",
    "Broward County, Florida",
    "Brown County, Illinois",
    "Brown County, Indiana",
    "Brown County, Kansas",
    "Brown County, Minnesota",
    "Brown County, Nebraska",
    "Brown County, Ohio",
    "Brown County, South Dakota",
    "Brown County, Texas",
    "Brown County, Wisconsin",
    "Brule County, South Dakota",
    "Brunswick County, North Carolina",
    "Brunswick County, Virginia",
    "Bryan County, Georgia",
    "Bryan County, Oklahoma",
    "Buchanan County, Iowa",
    "Buchanan County, Missouri",
    "Buchanan County, Virginia",
    "Buckingham County, Virginia",
    "Bucks County, Pennsylvania",
    "Buena Vista County, Iowa",
    "Buffalo County, Nebraska",
    "Buffalo County, Wisconsin",
    "Bullitt County, Kentucky",
    "Bulloch County, Georgia",
    "Bullock County, Alabama",
    "Buncombe County, North Carolina",
    "Bureau County, Illinois",
    "Burke County, Georgia",
    "Burke County, North Carolina",
    "Burke County, North Dakota",
    "Burleigh County, North Dakota",
    "Burleson County, Texas",
    "Burlington County, New Jersey",
    "Burnet County, Texas",
    "Burnett County, Wisconsin",
    "Burt County, Nebraska",
    "Butler County, Alabama",
    "Butler County, Iowa",
    "Butler County, Kansas",
    "Butler County, Kentucky",
    "Butler County, Missouri",
    "Butler County, Nebraska",
    "Butler County, Ohio",
    "Butler County, Pennsylvania",
    "Butte County, California",
    "Butte County, Idaho",
    "Butte County, South Dakota",
    "Butts County, Georgia",
    "Cabarrus County, North Carolina",
    "Cabell County, West Virginia",
    "Cache County, Utah",
    "Caddo Parish, Louisiana",
    "Caddo County, Oklahoma",
    "Calaveras County, California",
    "Calcasieu Parish, Louisiana",
    "Caldwell County, Kentucky",
    "Caldwell Parish, Louisiana",
    "Caldwell County, Missouri",
    "Caldwell County, North Carolina",
    "Caldwell County, Texas",
    "Caledonia County, Vermont",
    "Calhoun County, Alabama",
    "Calhoun County, Arkansas",
    "Calhoun County, Florida",
    "Calhoun County, Georgia",
    "Calhoun County, Illinois",
    "Calhoun County, Iowa",
    "Calhoun County, Michigan",
    "Calhoun County, Mississippi",
    "Calhoun County, South Carolina",
    "Calhoun County, Texas",
    "Calhoun County, West Virginia",
    "Callahan County, Texas",
    "Callaway County, Missouri",
    "Calloway County, Kentucky",
    "Calumet County, Wisconsin",
    "Calvert County, Maryland",
    "Camas County, Idaho",
    "Cambria County, Pennsylvania",
    "Camden County, Georgia",
    "Camden County, Missouri",
    "Camden County, New Jersey",
    "Camden County, North Carolina",
    "Cameron Parish, Louisiana",
    "Cameron County, Pennsylvania",
    "Cameron County, Texas",
    "Camp County, Texas",
    "Campbell County, Kentucky",
    "Campbell County, South Dakota",
    "Campbell County, Tennessee",
    "Campbell County, Virginia",
    "Campbell County, Wyoming",
    "Canadian County, Oklahoma",
    "Candler County, Georgia",
    "Cannon County, Tennessee",
    "Canyon County, Idaho",
    "Cape Girardeau County, Missouri",
    "Cape May County, New Jersey",
    "Carbon County, Montana",
    "Carbon County, Pennsylvania",
    "Carbon County, Utah",
    "Carbon County, Wyoming",
    "Caribou County, Idaho",
    "Carlisle County, Kentucky",
    "Carlton County, Minnesota",
    "Caroline County, Maryland",
    "Caroline County, Virginia",
    "Carroll County, Arkansas",
    "Carroll County, Georgia",
    "Carroll County, Illinois",
    "Carroll County, Indiana",
    "Carroll County, Iowa",
    "Carroll County, Kentucky",
    "Carroll County, Maryland",
    "Carroll County, Mississippi",
    "Carroll County, Missouri",
    "Carroll County, New Hampshire",
    "Carroll County, Ohio",
    "Carroll County, Tennessee",
    "Carroll County, Virginia",
    "Carson City, Nevada",
    "Carson County, Texas",
    "Carter County, Kentucky",
    "Carter County, Missouri",
    "Carter County, Montana",
    "Carter County, Oklahoma",
    "Carter County, Tennessee",
    "Carteret County, North Carolina",
    "Carver County, Minnesota",
    "Cascade County, Montana",
    "Casey County, Kentucky",
    "Cass County, Illinois",
    "Cass County, Indiana",
    "Cass County, Iowa",
    "Cass County, Michigan",
    "Cass County, Minnesota",
    "Cass County, Missouri",
    "Cass County, Nebraska",
    "Cass County, North Dakota",
    "Cass County, Texas",
    "Cassia County, Idaho",
    "Castro County, Texas",
    "Caswell County, North Carolina",
    "Catahoula Parish, Louisiana",
    "Catawba County, North Carolina",
    "Catoosa County, Georgia",
    "Catron County, New Mexico",
    "Cattaraugus County, New York",
    "Cavalier County, North Dakota",
    "Cayuga County, New York",
    "Cecil County, Maryland",
    "Cedar County, Iowa",
    "Cedar County, Missouri",
    "Cedar County, Nebraska",
    "Centre County, Pennsylvania",
    "Cerro Gordo County, Iowa",
    "Chaffee County, Colorado",
    "Chambers County, Alabama",
    "Chambers County, Texas",
    "Champaign County, Illinois",
    "Champaign County, Ohio",
    "Chariton County, Missouri",
    "Charles City County, Virginia",
    "Charles County, Maryland",
    "Charles Mix County, South Dakota",
    "Charleston County, South Carolina",
    "Charlevoix County, Michigan",
    "Charlotte County, Florida",
    "Charlotte County, Virginia",
    "Charlton County, Georgia",
    "Chase County, Kansas",
    "Chase County, Nebraska",
    "Chatham County, Georgia",
    "Chatham County, North Carolina",
    "Chattahoochee County, Georgia",
    "Chattooga County, Georgia",
    "Chautauqua County, Kansas",
    "Chautauqua County, New York",
    "Chaves County, New Mexico",
    "Cheatham County, Tennessee",
    "Cheboygan County, Michigan",
    "Chelan County, Washington",
    "Chemung County, New York",
    "Chenango County, New York",
    "Cherokee County, Alabama",
    "Cherokee County, Georgia",
    "Cherokee County, Iowa",
    "Cherokee County, Kansas",
    "Cherokee County, North Carolina",
    "Cherokee County, Oklahoma",
    "Cherokee County, South Carolina",
    "Cherokee County, Texas",
    "Cherry County, Nebraska",
    "Cheshire County, New Hampshire",
    "Chester County, Pennsylvania",
    "Chester County, South Carolina",
    "Chester County, Tennessee",
    "Chesterfield County, South Carolina",
    "Chesterfield County, Virginia",
    "Cheyenne County, Colorado",
    "Cheyenne County, Kansas",
    "Cheyenne County, Nebraska",
    "Chickasaw County, Iowa",
    "Chickasaw County, Mississippi",
    "Chicot County, Arkansas",
    "Childress County, Texas",
    "Chilton County, Alabama",
    "Chippewa County, Michigan",
    "Chippewa County, Minnesota",
    "Chippewa County, Wisconsin",
    "Chisago County, Minnesota",
    "Chittenden County, Vermont",
    "Choctaw County, Alabama",
    "Choctaw County, Mississippi",
    "Choctaw County, Oklahoma",
    "Chouteau County, Montana",
    "Chowan County, North Carolina",
    "Christian County, Illinois",
    "Christian County, Kentucky",
    "Christian County, Missouri",
    "Churchill County, Nevada",
    "Cibola County, New Mexico",
    "Cimarron County, Oklahoma",
    "Citrus County, Florida",
    "Clackamas County, Oregon",
    "Claiborne Parish, Louisiana",
    "Claiborne County, Mississippi",
    "Claiborne County, Tennessee",
    "Clallam County, Washington",
    "Clare County, Michigan",
    "Clarendon County, South Carolina",
    "Clarion County, Pennsylvania",
    "Clark County, Arkansas",
    "Clark County, Idaho",
    "Clark County, Illinois",
    "Clark County, Indiana",
    "Clark County, Kansas",
    "Clark County, Kentucky",
    "Clark County, Missouri",
    "Clark County, Ohio",
    "Clark County, South Dakota",
    "Clark County, Washington",
    "Clark County, Wisconsin",
    "Clarke County, Alabama",
    "Clarke County, Georgia",
    "Clarke County, Iowa",
    "Clarke County, Virginia",
    "Clatsop County, Oregon",
    "Clay County, Alabama",
    "Clay County, Arkansas",
    "Clay County, Florida",
    "Clay County, Georgia",
    "Clay County, Illinois",
    "Clay County, Indiana",
    "Clay County, Iowa",
    "Clay County, Kansas",
    "Clay County, Kentucky",
    "Clay County, Minnesota",
    "Clay County, Mississippi",
    "Clay County, Missouri",
    "Clay County, Nebraska",
    "Clay County, North Carolina",
    "Clay County, South Dakota",
    "Clay County, Tennessee",
    "Clay County, Texas",
    "Clay County, West Virginia",
    "Clayton County, Georgia",
    "Clayton County, Iowa",
    "Clear Creek County, Colorado",
    "Clearwater County, Idaho",
    "Clearwater County, Minnesota",
    "Cleburne County, Alabama",
    "Cleburne County, Arkansas",
    "Clermont County, Ohio",
    "Cleveland County, Arkansas",
    "Cleveland County, North Carolina",
    "Cleveland County, Oklahoma",
    "Clinch County, Georgia",
    "Clinton County, Illinois",
    "Clinton County, Indiana",
    "Clinton County, Iowa",
    "Clinton County, Kentucky",
    "Clinton County, Michigan",
    "Clinton County, Missouri",
    "Clinton County, New York",
    "Clinton County, Ohio",
    "Clinton County, Pennsylvania",
    "Cloud County, Kansas",
    "Coahoma County, Mississippi",
    "Coal County, Oklahoma",
    "Cobb County, Georgia",
    "Cochise County, Arizona",
    "Cochran County, Texas",
    "Cocke County, Tennessee",
    "Coconino County, Arizona",
    "Codington County, South Dakota",
    "Coffee County, Alabama",
    "Coffee County, Georgia",
    "Coffee County, Tennessee",
    "Coffey County, Kansas",
    "Coke County, Texas",
    "Colbert County, Alabama",
    "Cole County, Missouri",
    "Coleman County, Texas",
    "Coles County, Illinois",
    "Colfax County, Nebraska",
    "Colfax County, New Mexico",
    "Colleton County, South Carolina",
    "Collier County, Florida",
    "Collin County, Texas",
    "Collingsworth County, Texas",
    "Colorado County, Texas",
    "Colquitt County, Georgia",
    "Columbia County, Arkansas",
    "Columbia County, Florida",
    "Columbia County, Georgia",
    "Columbia County, New York",
    "Columbia County, Oregon",
    "Columbia County, Washington",
    "Columbia County, Wisconsin",
    "Columbiana County, Ohio",
    "Columbus County, North Carolina",
    "Colusa County, California",
    "Comal County, Texas",
    "Comanche County, Kansas",
    "Comanche County, Oklahoma",
    "Comanche County, Texas",
    "Concho County, Texas",
    "Concordia Parish, Louisiana",
    "Conecuh County, Alabama",
    "Conejos County, Colorado",
    "Contra Costa County, California",
    "Converse County, Wyoming",
    "Conway County, Arkansas",
    "Cook County, Georgia",
    "Cook County, Illinois",
    "Cook County, Minnesota",
    "Cooke County, Texas",
    "Cooper County, Missouri",
    "Coos County, New Hampshire",
    "Coos County, Oregon",
    "Coosa County, Alabama",
    "Copiah County, Mississippi",
    "Corson County, South Dakota",
    "Cortland County, New York",
    "Coryell County, Texas",
    "Coshocton County, Ohio",
    "Costilla County, Colorado",
    "Cottle County, Texas",
    "Cotton County, Oklahoma",
    "Cottonwood County, Minnesota",
    "Covington County, Alabama",
    "Covington County, Mississippi",
    "Coweta County, Georgia",
    "Cowley County, Kansas",
    "Cowlitz County, Washington",
    "Craig County, Oklahoma",
    "Craig County, Virginia",
    "Craighead County, Arkansas",
    "Crane County, Texas",
    "Craven County, North Carolina",
    "Crawford County, Arkansas",
    "Crawford County, Georgia",
    "Crawford County, Illinois",
    "Crawford County, Indiana",
    "Crawford County, Iowa",
    "Crawford County, Kansas",
    "Crawford County, Michigan",
    "Crawford County, Missouri",
    "Crawford County, Ohio",
    "Crawford County, Wisconsin",
    "Creek County, Oklahoma",
    "Crenshaw County, Alabama",
    "Crisp County, Georgia",
    "Crittenden County, Arkansas",
    "Crittenden County, Kentucky",
    "Crockett County, Tennessee",
    "Crockett County, Texas",
    "Crook County, Oregon",
    "Crook County, Wyoming",
    "Crosby County, Texas",
    "Cross County, Arkansas",
    "Crow Wing County, Minnesota",
    "Crowley County, Colorado",
    "Culberson County, Texas",
    "Cullman County, Alabama",
    "Culpeper County, Virginia",
    "Cumberland County, Illinois",
    "Cumberland County, Kentucky",
    "Cumberland County, Maine",
    "Cumberland County, New Jersey",
    "Cumberland County, North Carolina",
    "Cumberland County, Pennsylvania",
    "Cumberland County, Tennessee",
    "Cumberland County, Virginia",
    "Cuming County, Nebraska",
    "Currituck County, North Carolina",
    "Curry County, New Mexico",
    "Curry County, Oregon",
    "Custer County, Colorado",
    "Custer County, Idaho",
    "Custer County, Montana",
    "Custer County, Nebraska",
    "Custer County, Oklahoma",
    "Custer County, South Dakota",
    "Cuyahoga County, Ohio",
    "Dade County, Georgia",
    "Dade County, Missouri",
    "Daggett County, Utah",
    "Dakota County, Minnesota",
    "Dakota County, Nebraska",
    "Dale County, Alabama",
    "Dallam County, Texas",
    "Dallas County, Alabama",
    "Dallas County, Arkansas",
    "Dallas County, Iowa",
    "Dallas County, Missouri",
    "Dallas County, Texas",
    "Dane County, Wisconsin",
    "Daniels County, Montana",
    "Dare County, North Carolina",
    "Darke County, Ohio",
    "Darlington County, South Carolina",
    "Davidson County, North Carolina",
    "Davie County, North Carolina",
    "Daviess County, Indiana",
    "Daviess County, Kentucky",
    "Daviess County, Missouri",
    "Davis County, Iowa",
    "Davis County, Utah",
    "Davison County, South Dakota",
    "Dawes County, Nebraska",
    "Dawson County, Georgia",
    "Dawson County, Montana",
    "Dawson County, Nebraska",
    "Dawson County, Texas",
    "Day County, South Dakota",
    "De Baca County, New Mexico",
    "De Soto Parish, Louisiana",
    "De Witt County, Illinois",
    "Deaf Smith County, Texas",
    "Dearborn County, Indiana",
    "Decatur County, Georgia",
    "Decatur County, Indiana",
    "Decatur County, Iowa",
    "Decatur County, Kansas",
    "Decatur County, Tennessee",
    "Deer Lodge County, Montana",
    "Defiance County, Ohio",
    "DeKalb County, Alabama",
    "DeKalb County, Georgia",
    "DeKalb County, Illinois",
    "DeKalb County, Indiana",
    "DeKalb County, Missouri",
    "DeKalb County, Tennessee",
    "Del Norte County, California",
    "Delaware County, Indiana",
    "Delaware County, Iowa",
    "Delaware County, New York",
    "Delaware County, Ohio",
    "Delaware County, Oklahoma",
    "Delta County, Colorado",
    "Delta County, Michigan",
    "Delta County, Texas",
    "Dent County, Missouri",
    "Denton County, Texas",
    "Des Moines County, Iowa",
    "Deschutes County, Oregon",
    "Desha County, Arkansas",
    "DeSoto County, Florida",
    "DeSoto County, Mississippi",
    "Deuel County, Nebraska",
    "Deuel County, South Dakota",
    "Dewey County, Oklahoma",
    "Dewey County, South Dakota",
    "DeWitt County, Texas",
    "Dickens County, Texas",
    "Dickenson County, Virginia",
    "Dickey County, North Dakota",
    "Dickinson County, Iowa",
    "Dickinson County, Kansas",
    "Dickinson County, Michigan",
    "Dickson County, Tennessee",
    "Dillon County, South Carolina",
    "Dimmit County, Texas",
    "Dinwiddie County, Virginia",
    "Divide County, North Dakota",
    "Dixie County, Florida",
    "Dixon County, Nebraska",
    "Doddridge County, West Virginia",
    "Dodge County, Georgia",
    "Dodge County, Minnesota",
    "Dodge County, Nebraska",
    "Dodge County, Wisconsin",
    "Dolores County, Colorado",
    "Doña Ana County, New Mexico",
    "Doniphan County, Kansas",
    "Donley County, Texas",
    "Dooly County, Georgia",
    "Door County, Wisconsin",
    "Dorchester County, Maryland",
    "Dorchester County, South Carolina",
    "Dougherty County, Georgia",
    "Douglas County, Colorado",
    "Douglas County, Georgia",
    "Douglas County, Illinois",
    "Douglas County, Kansas",
    "Douglas County, Minnesota",
    "Douglas County, Missouri",
    "Douglas County, Nebraska",
    "Douglas County, Nevada",
    "Douglas County, Oregon",
    "Douglas County, South Dakota",
    "Douglas County, Washington",
    "Douglas County, Wisconsin",
    "Drew County, Arkansas",
    "Dubois County, Indiana",
    "Dubuque County, Iowa",
    "Duchesne County, Utah",
    "Dukes County, Massachusetts",
    "Dundy County, Nebraska",
    "Dunklin County, Missouri",
    "Dunn County, North Dakota",
    "Dunn County, Wisconsin",
    "DuPage County, Illinois",
    "Duplin County, North Carolina",
    "Durham County, North Carolina",
    "Dutchess County, New York",
    "Duval County, Florida",
    "Duval County, Texas",
    "Dyer County, Tennessee",
    "Eagle County, Colorado",
    "Early County, Georgia",
    "East Baton Rouge Parish, Louisiana",
    "East Carroll Parish, Louisiana",
    "East Feliciana Parish, Louisiana",
    "Eastland County, Texas",
    "Eaton County, Michigan",
    "Eau Claire County, Wisconsin",
    "Echols County, Georgia",
    "Ector County, Texas",
    "Eddy County, New Mexico",
    "Eddy County, North Dakota",
    "Edgar County, Illinois",
    "Edgecombe County, North Carolina",
    "Edgefield County, South Carolina",
    "Edmonson County, Kentucky",
    "Edmunds County, South Dakota",
    "Edwards County, Illinois",
    "Edwards County, Kansas",
    "Edwards County, Texas",
    "Effingham County, Georgia",
    "Effingham County, Illinois",
    "El Dorado County, California",
    "El Paso County, Colorado",
    "El Paso County, Texas",
    "Elbert County, Colorado",
    "Elbert County, Georgia",
    "Elk County, Kansas",
    "Elk County, Pennsylvania",
    "Elkhart County, Indiana",
    "Elko County, Nevada",
    "Elliott County, Kentucky",
    "Ellis County, Kansas",
    "Ellis County, Oklahoma",
    "Ellis County, Texas",
    "Ellsworth County, Kansas",
    "Elmore County, Alabama",
    "Elmore County, Idaho",
    "Emanuel County, Georgia",
    "Emery County, Utah",
    "Emmet County, Iowa",
    "Emmet County, Michigan",
    "Emmons County, North Dakota",
    "Erath County, Texas",
    "Erie County, New York",
    "Erie County, Ohio",
    "Erie County, Pennsylvania",
    "Escambia County, Alabama",
    "Escambia County, Florida",
    "Esmeralda County, Nevada",
    "Essex County, New Jersey",
    "Essex County, New York",
    "Essex County, Vermont",
    "Essex County, Virginia",
    "Estill County, Kentucky",
    "Etowah County, Alabama",
    "Eureka County, Nevada",
    "Evangeline Parish, Louisiana",
    "Evans County, Georgia",
    "Fairfax County, Virginia",
    "Fairfield County, Ohio",
    "Fairfield County, South Carolina",
    "Fall River County, South Dakota",
    "Fallon County, Montana",
    "Falls County, Texas",
    "Fannin County, Georgia",
    "Fannin County, Texas",
    "Faribault County, Minnesota",
    "Faulk County, South Dakota",
    "Faulkner County, Arkansas",
    "Fauquier County, Virginia",
    "Fayette County, Alabama",
    "Fayette County, Georgia",
    "Fayette County, Illinois",
    "Fayette County, Indiana",
    "Fayette County, Iowa",
    "Fayette County, Kentucky",
    "Fayette County, Ohio",
    "Fayette County, Tennessee",
    "Fayette County, Texas",
    "Fayette County, West Virginia",
    "Fentress County, Tennessee",
    "Fergus County, Montana",
    "Ferry County, Washington",
    "Fillmore County, Minnesota",
    "Fillmore County, Nebraska",
    "Finney County, Kansas",
    "Fisher County, Texas",
    "Flagler County, Florida",
    "Flathead County, Montana",
    "Fleming County, Kentucky",
    "Florence County, South Carolina",
    "Florence County, Wisconsin",
    "Floyd County, Georgia",
    "Floyd County, Indiana",
    "Floyd County, Iowa",
    "Floyd County, Kentucky",
    "Floyd County, Texas",
    "Floyd County, Virginia",
    "Fluvanna County, Virginia",
    "Foard County, Texas",
    "Fond du Lac County, Wisconsin",
    "Ford County, Illinois",
    "Ford County, Kansas",
    "Forest County, Pennsylvania",
    "Forest County, Wisconsin",
    "Forrest County, Mississippi",
    "Forsyth County, Georgia",
    "Forsyth County, North Carolina",
    "Fort Bend County, Texas",
    "Foster County, North Dakota",
    "Fountain County, Indiana",
    "Franklin County, Alabama",
    "Franklin County, Arkansas",
    "Franklin County, Florida",
    "Franklin County, Georgia",
    "Franklin County, Idaho",
    "Franklin County, Illinois",
    "Franklin County, Indiana",
    "Franklin County, Iowa",
    "Franklin County, Kansas",
    "Franklin County, Kentucky",
    "Franklin Parish, Louisiana",
    "Franklin County, Maine",
    "Franklin County, Mississippi",
    "Franklin County, Missouri",
    "Franklin County, Nebraska",
    "Franklin County, New York",
    "Franklin County, North Carolina",
    "Franklin County, Ohio",
    "Franklin County, Pennsylvania",
    "Franklin County, Tennessee",
    "Franklin County, Texas",
    "Franklin County, Vermont",
    "Franklin County, Virginia",
    "Franklin County, Washington",
    "Frederick County, Maryland",
    "Frederick County, Virginia",
    "Freeborn County, Minnesota",
    "Freestone County, Texas",
    "Fremont County, Colorado",
    "Fremont County, Idaho",
    "Fremont County, Iowa",
    "Fremont County, Wyoming",
    "Fresno County, California",
    "Frio County, Texas",
    "Frontier County, Nebraska",
    "Fulton County, Arkansas",
    "Fulton County, Georgia",
    "Fulton County, Illinois",
    "Fulton County, Indiana",
    "Fulton County, Kentucky",
    "Fulton County, New York",
    "Fulton County, Ohio",
    "Fulton County, Pennsylvania",
    "Furnas County, Nebraska",
    "Gadsden County, Florida",
    "Gage County, Nebraska",
    "Gaines County, Texas",
    "Gallatin County, Illinois",
    "Gallatin County, Kentucky",
    "Gallatin County, Montana",
    "Gallia County, Ohio",
    "Galveston County, Texas",
    "Garden County, Nebraska",
    "Garfield County, Colorado",
    "Garfield County, Montana",
    "Garfield County, Nebraska",
    "Garfield County, Oklahoma",
    "Garfield County, Utah",
    "Garfield County, Washington",
    "Garland County, Arkansas",
    "Garrard County, Kentucky",
    "Garrett County, Maryland",
    "Garvin County, Oklahoma",
    "Garza County, Texas",
    "Gasconade County, Missouri",
    "Gaston County, North Carolina",
    "Gates County, North Carolina",
    "Geary County, Kansas",
    "Geauga County, Ohio",
    "Gem County, Idaho",
    "Genesee County, Michigan",
    "Genesee County, New York",
    "Geneva County, Alabama",
    "Gentry County, Missouri",
    "George County, Mississippi",
    "Georgetown County, South Carolina",
    "Gibson County, Indiana",
    "Gibson County, Tennessee",
    "Gila County, Arizona",
    "Gilchrist County, Florida",
    "Giles County, Tennessee",
    "Giles County, Virginia",
    "Gillespie County, Texas",
    "Gilliam County, Oregon",
    "Gilmer County, Georgia",
    "Gilmer County, West Virginia",
    "Gilpin County, Colorado",
    "Glacier County, Montana",
    "Glades County, Florida",
    "Gladwin County, Michigan",
    "Glascock County, Georgia",
    "Glasscock County, Texas",
    "Glenn County, California",
    "Gloucester County, New Jersey",
    "Gloucester County, Virginia",
    "Glynn County, Georgia",
    "Gogebic County, Michigan",
    "Golden Valley County, Montana",
    "Golden Valley County, North Dakota",
    "Goliad County, Texas",
    "Gonzales County, Texas",
    "Goochland County, Virginia",
    "Goodhue County, Minnesota",
    "Gooding County, Idaho",
    "Gordon County, Georgia",
    "Goshen County, Wyoming",
    "Gosper County, Nebraska",
    "Gove County, Kansas",
    "Grady County, Georgia",
    "Grady County, Oklahoma",
    "Grafton County, New Hampshire",
    "Graham County, Arizona",
    "Graham County, Kansas",
    "Graham County, North Carolina",
    "Grainger County, Tennessee",
    "Grand County, Colorado",
    "Grand County, Utah",
    "Grand Forks County, North Dakota",
    "Grand Isle County, Vermont",
    "Grand Traverse County, Michigan",
    "Granite County, Montana",
    "Grant County, Arkansas",
    "Grant County, Indiana",
    "Grant County, Kansas",
    "Grant County, Kentucky",
    "Grant Parish, Louisiana",
    "Grant County, Minnesota",
    "Grant County, Nebraska",
    "Grant County, New Mexico",
    "Grant County, North Dakota",
    "Grant County, Oklahoma",
    "Grant County, Oregon",
    "Grant County, Washington",
    "Grant County, West Virginia",
    "Grant County, Wisconsin",
    "Granville County, North Carolina",
    "Gratiot County, Michigan",
    "Graves County, Kentucky",
    "Gray County, Kansas",
    "Gray County, Texas",
    "Grays Harbor County, Washington",
    "Grayson County, Kentucky",
    "Grayson County, Texas",
    "Grayson County, Virginia",
    "Greeley County, Kansas",
    "Greeley County, Nebraska",
    "Green County, Kentucky",
    "Green County, Wisconsin",
    "Green Lake County, Wisconsin",
    "Greenbrier County, West Virginia",
    "Greene County, Alabama",
    "Greene County, Arkansas",
    "Greene County, Georgia",
    "Greene County, Illinois",
    "Greene County, Indiana",
    "Greene County, Iowa",
    "Greene County, Mississippi",
    "Greene County, Missouri",
    "Greene County, New York",
    "Greene County, North Carolina",
    "Greene County, Ohio",
    "Greene County, Pennsylvania",
    "Greene County, Tennessee",
    "Greene County, Virginia",
    "Greenlee County, Arizona",
    "Greensville County, Virginia",
    "Greenup County, Kentucky",
    "Greenville County, South Carolina",
    "Greenwood County, Kansas",
    "Greenwood County, South Carolina",
    "Greer County, Oklahoma",
    "Gregg County, Texas",
    "Gregory County, South Dakota",
    "Grenada County, Mississippi",
    "Griggs County, North Dakota",
    "Grimes County, Texas",
    "Grundy County, Illinois",
    "Grundy County, Iowa",
    "Grundy County, Missouri",
    "Grundy County, Tennessee",
    "Guadalupe County, New Mexico",
    "Guadalupe County, Texas",
    "Guernsey County, Ohio",
    "Guilford County, North Carolina",
    "Gulf County, Florida",
    "Gunnison County, Colorado",
    "Guthrie County, Iowa",
    "Gwinnett County, Georgia",
    "Habersham County, Georgia",
    "Hale County, Alabama",
    "Hale County, Texas",
    "Halifax County, North Carolina",
    "Halifax County, Virginia",
    "Hall County, Georgia",
    "Hall County, Nebraska",
    "Hall County, Texas",
    "Hamblen County, Tennessee",
    "Hamilton County, Florida",
    "Hamilton County, Illinois",
    "Hamilton County, Indiana",
    "Hamilton County, Iowa",
    "Hamilton County, Kansas",
    "Hamilton County, Nebraska",
    "Hamilton County, New York",
    "Hamilton County, Ohio",
    "Hamilton County, Tennessee",
    "Hamilton County, Texas",
    "Hamlin County, South Dakota",
    "Hampshire County, West Virginia",
    "Hampton County, South Carolina",
    "Hancock County, Georgia",
    "Hancock County, Illinois",
    "Hancock County, Indiana",
    "Hancock County, Iowa",
    "Hancock County, Kentucky",
    "Hancock County, Maine",
    "Hancock County, Mississippi",
    "Hancock County, Ohio",
    "Hancock County, Tennessee",
    "Hancock County, West Virginia",
    "Hand County, South Dakota",
    "Hanover County, Virginia",
    "Hansford County, Texas",
    "Hanson County, South Dakota",
    "Haralson County, Georgia",
    "Hardee County, Florida",
    "Hardeman County, Tennessee",
    "Hardeman County, Texas",
    "Hardin County, Illinois",
    "Hardin County, Iowa",
    "Hardin County, Kentucky",
    "Hardin County, Ohio",
    "Hardin County, Tennessee",
    "Hardin County, Texas",
    "Harding County, New Mexico",
    "Harding County, South Dakota",
    "Hardy County, West Virginia",
    "Harford County, Maryland",
    "Harlan County, Kentucky",
    "Harlan County, Nebraska",
    "Harmon County, Oklahoma",
    "Harnett County, North Carolina",
    "Harney County, Oregon",
    "Harper County, Kansas",
    "Harper County, Oklahoma",
    "Harris County, Georgia",
    "Harris County, Texas",
    "Harrison County, Indiana",
    "Harrison County, Iowa",
    "Harrison County, Kentucky",
    "Harrison County, Mississippi",
    "Harrison County, Missouri",
    "Harrison County, Ohio",
    "Harrison County, Texas",
    "Harrison County, West Virginia",
    "Hart County, Georgia",
    "Hart County, Kentucky",
    "Hartley County, Texas",
    "Harvey County, Kansas",
    "Haskell County, Kansas",
    "Haskell County, Oklahoma",
    "Haskell County, Texas",
    "Hawaii County, Hawaii",
    "Hawkins County, Tennessee",
    "Hayes County, Nebraska",
    "Hays County, Texas",
    "Haywood County, North Carolina",
    "Haywood County, Tennessee",
    "Heard County, Georgia",
    "Hemphill County, Texas",
    "Hempstead County, Arkansas",
    "Henderson County, Illinois",
    "Henderson County, Kentucky",
    "Henderson County, North Carolina",
    "Henderson County, Tennessee",
    "Henderson County, Texas",
    "Hendricks County, Indiana",
    "Hendry County, Florida",
    "Hennepin County, Minnesota",
    "Henrico County, Virginia",
    "Henry County, Alabama",
    "Henry County, Georgia",
    "Henry County, Illinois",
    "Henry County, Indiana",
    "Henry County, Iowa",
    "Henry County, Kentucky",
    "Henry County, Missouri",
    "Henry County, Ohio",
    "Henry County, Tennessee",
    "Henry County, Virginia",
    "Herkimer County, New York",
    "Hernando County, Florida",
    "Hertford County, North Carolina",
    "Hettinger County, North Dakota",
    "Hickman County, Kentucky",
    "Hickman County, Tennessee",
    "Hickory County, Missouri",
    "Hidalgo County, New Mexico",
    "Hidalgo County, Texas",
    "Highland County, Ohio",
    "Highland County, Virginia",
    "Highlands County, Florida",
    "Hill County, Montana",
    "Hill County, Texas",
    "Hillsborough County, Florida",
    "Hillsborough County, New Hampshire",
    "Hillsdale County, Michigan",
    "Hinds County, Mississippi",
    "Hinsdale County, Colorado",
    "Hitchcock County, Nebraska",
    "Hocking County, Ohio",
    "Hockley County, Texas",
    "Hodgeman County, Kansas",
    "Hoke County, North Carolina",
    "Holmes County, Florida",
    "Holmes County, Mississippi",
    "Holmes County, Ohio",
    "Holt County, Missouri",
    "Holt County, Nebraska",
    "Hood County, Texas",
    "Hood River County, Oregon",
    "Hooker County, Nebraska",
    "Hopkins County, Kentucky",
    "Hopkins County, Texas",
    "Horry County, South Carolina",
    "Hot Spring County, Arkansas",
    "Hot Springs County, Wyoming",
    "Houghton County, Michigan",
    "Houston County, Alabama",
    "Houston County, Georgia",
    "Houston County, Minnesota",
    "Houston County, Tennessee",
    "Houston County, Texas",
    "Howard County, Arkansas",
    "Howard County, Indiana",
    "Howard County, Iowa",
    "Howard County, Maryland",
    "Howard County, Missouri",
    "Howard County, Nebraska",
    "Howard County, Texas",
    "Howell County, Missouri",
    "Hubbard County, Minnesota",
    "Hudson County, New Jersey",
    "Hudspeth County, Texas",
    "Huerfano County, Colorado",
    "Hughes County, Oklahoma",
    "Hughes County, South Dakota",
    "Humboldt County, California",
    "Humboldt County, Iowa",
    "Humboldt County, Nevada",
    "Humphreys County, Tennessee",
    "Hunt County, Texas",
    "Hunterdon County, New Jersey",
    "Huntington County, Indiana",
    "Huron County, Michigan",
    "Huron County, Ohio",
    "Hutchinson County, South Dakota",
    "Hutchinson County, Texas",
    "Hyde County, North Carolina",
    "Hyde County, South Dakota",
    "Iberia Parish, Louisiana",
    "Iberville Parish, Louisiana",
    "Ida County, Iowa",
    "Idaho County, Idaho",
    "Imperial County, California",
    "Independence County, Arkansas",
    "Indian River County, Florida",
    "Indiana County, Pennsylvania",
    "Ingham County, Michigan",
    "Inyo County, California",
    "Ionia County, Michigan",
    "Iosco County, Michigan",
    "Iowa County, Iowa",
    "Iowa County, Wisconsin",
    "Iredell County, North Carolina",
    "Irion County, Texas",
    "Iron County, Michigan",
    "Iron County, Missouri",
    "Iron County, Utah",
    "Iron County, Wisconsin",
    "Iroquois County, Illinois",
    "Irwin County, Georgia",
    "Isabella County, Michigan",
    "Isanti County, Minnesota",
    "Island County, Washington",
    "Isle of Wight County, Virginia",
    "Issaquena County, Mississippi",
    "Itasca County, Minnesota",
    "Itawamba County, Mississippi",
    "Izard County, Arkansas",
    "Jack County, Texas",
    "Jackson County, Alabama",
    "Jackson County, Arkansas",
    "Jackson County, Colorado",
    "Jackson County, Florida",
    "Jackson County, Georgia",
    "Jackson County, Illinois",
    "Jackson County, Indiana",
    "Jackson County, Iowa",
    "Jackson County, Kansas",
    "Jackson County, Kentucky",
    "Jackson Parish, Louisiana",
    "Jackson County, Michigan",
    "Jackson County, Minnesota",
    "Jackson County, Mississippi",
    "Jackson County, Missouri",
    "Jackson County, North Carolina",
    "Jackson County, Ohio",
    "Jackson County, Oklahoma",
    "Jackson County, Oregon",
    "Jackson County, South Dakota",
    "Jackson County, Tennessee",
    "Jackson County, Texas",
    "Jackson County, West Virginia",
    "Jackson County, Wisconsin",
    "James City County, Virginia",
    "Jasper County, Georgia",
    "Jasper County, Illinois",
    "Jasper County, Iowa",
    "Jasper County, Mississippi",
    "Jasper County, Missouri",
    "Jasper County, South Carolina",
    "Jasper County, Texas",
    "Jay County, Indiana",
    "Jeff Davis County, Georgia",
    "Jeff Davis County, Texas",
    "Jefferson County, Alabama",
    "Jefferson County, Arkansas",
    "Jefferson County, Colorado",
    "Jefferson County, Florida",
    "Jefferson County, Georgia",
    "Jefferson County, Idaho",
    "Jefferson County, Illinois",
    "Jefferson County, Indiana",
    "Jefferson County, Iowa",
    "Jefferson County, Kansas",
    "Jefferson County, Kentucky",
    "Jefferson Parish, Louisiana",
    "Jefferson County, Mississippi",
    "Jefferson County, Missouri",
    "Jefferson County, Montana",
    "Jefferson County, Nebraska",
    "Jefferson County, New York",
    "Jefferson County, Ohio",
    "Jefferson County, Oklahoma",
    "Jefferson County, Oregon",
    "Jefferson County, Pennsylvania",
    "Jefferson County, Tennessee",
    "Jefferson County, Texas",
    "Jefferson County, Washington",
    "Jefferson County, West Virginia",
    "Jefferson County, Wisconsin",
    "Jefferson Davis Parish, Louisiana",
    "Jenkins County, Georgia",
    "Jennings County, Indiana",
    "Jerauld County, South Dakota",
    "Jerome County, Idaho",
    "Jersey County, Illinois",
    "Jessamine County, Kentucky",
    "Jewell County, Kansas",
    "Jim Hogg County, Texas",
    "Jim Wells County, Texas",
    "Jo Daviess County, Illinois",
    "Johnson County, Arkansas",
    "Johnson County, Georgia",
    "Johnson County, Illinois",
    "Johnson County, Indiana",
    "Johnson County, Iowa",
    "Johnson County, Kansas",
    "Johnson County, Kentucky",
    "Johnson County, Missouri",
    "Johnson County, Nebraska",
    "Johnson County, Tennessee",
    "Johnson County, Texas",
    "Johnson County, Wyoming",
    "Johnston County, North Carolina",
    "Johnston County, Oklahoma",
    "Jones County, Georgia",
    "Jones County, Iowa",
    "Jones County, Mississippi",
    "Jones County, North Carolina",
    "Jones County, South Dakota",
    "Jones County, Texas",
    "Josephine County, Oregon",
    "Juab County, Utah",
    "Judith Basin County, Montana",
    "Juneau County, Wisconsin",
    "Juniata County, Pennsylvania",
    "Kalamazoo County, Michigan",
    "Kalkaska County, Michigan",
    "Kanabec County, Minnesota",
    "Kanawha County, West Virginia",
    "Kandiyohi County, Minnesota",
    "Kane County, Illinois",
    "Kane County, Utah",
    "Kankakee County, Illinois",
    "Karnes County, Texas",
    "Kauai County, Hawaii",
    "Kaufman County, Texas",
    "Kay County, Oklahoma",
    "Kearney County, Nebraska",
    "Kearny County, Kansas",
    "Keith County, Nebraska",
    "Kemper County, Mississippi",
    "Kendall County, Illinois",
    "Kendall County, Texas",
    "Kenedy County, Texas",
    "Kennebec County, Maine",
    "Kenosha County, Wisconsin",
    "Kent County, Maryland",
    "Kent County, Michigan",
    "Kent County, Texas",
    "Kenton County, Kentucky",
    "Keokuk County, Iowa",
    "Kern County, California",
    "Kerr County, Texas",
    "Kershaw County, South Carolina",
    "Kewaunee County, Wisconsin",
    "Keweenaw County, Michigan",
    "Keya Paha County, Nebraska",
    "Kidder County, North Dakota",
    "Kimball County, Nebraska",
    "Kimble County, Texas",
    "King and Queen County, Virginia",
    "King County, Texas",
    "King County, Washington",
    "King George County, Virginia",
    "King William County, Virginia",
    "Kingfisher County, Oklahoma",
    "Kingman County, Kansas",
    "Kings County, California",
    "Kingsbury County, South Dakota",
    "Kinney County, Texas",
    "Kiowa County, Colorado",
    "Kiowa County, Kansas",
    "Kiowa County, Oklahoma",
    "Kit Carson County, Colorado",
    "Kitsap County, Washington",
    "Kittitas County, Washington",
    "Kittson County, Minnesota",
    "Klamath County, Oregon",
    "Kleberg County, Texas",
    "Klickitat County, Washington",
    "Knott County, Kentucky",
    "Knox County, Illinois",
    "Knox County, Indiana",
    "Knox County, Kentucky",
    "Knox County, Maine",
    "Knox County, Missouri",
    "Knox County, Nebraska",
    "Knox County, Ohio",
    "Knox County, Tennessee",
    "Knox County, Texas",
    "Koochiching County, Minnesota",
    "Kootenai County, Idaho",
    "Kosciusko County, Indiana",
    "Kossuth County, Iowa",
    "La Crosse County, Wisconsin",
    "La Paz County, Arizona",
    "La Plata County, Colorado",
    "La Salle County, Texas",
    "Labette County, Kansas",
    "Lac qui Parle County, Minnesota",
    "Laclede County, Missouri",
    "Lafayette County, Arkansas",
    "Lafayette County, Florida",
    "Lafayette Parish, Louisiana",
    "Lafayette County, Mississippi",
    "Lafayette County, Missouri",
    "Lafayette County, Wisconsin",
    "Lafourche Parish, Louisiana",
    "LaGrange County, Indiana",
    "Lake County, California",
    "Lake County, Colorado",
    "Lake County, Florida",
    "Lake County, Illinois",
    "Lake County, Indiana",
    "Lake County, Michigan",
    "Lake County, Minnesota",
    "Lake County, Montana",
    "Lake County, Ohio",
    "Lake County, Oregon",
    "Lake County, South Dakota",
    "Lake County, Tennessee",
    "Lake of the Woods County, Minnesota",
    "Lamar County, Alabama",
    "Lamar County, Georgia",
    "Lamar County, Mississippi",
    "Lamar County, Texas",
    "Lamb County, Texas",
    "Lamoille County, Vermont",
    "LaMoure County, North Dakota",
    "Lampasas County, Texas",
    "Lancaster County, Nebraska",
    "Lancaster County, Pennsylvania",
    "Lancaster County, South Carolina",
    "Lancaster County, Virginia",
    "Lander County, Nevada",
    "Lane County, Kansas",
    "Lane County, Oregon",
    "Langlade County, Wisconsin",
    "Lanier County, Georgia",
    "Lapeer County, Michigan",
    "LaPorte County, Indiana",
    "Laramie County, Wyoming",
    "Larimer County, Colorado",
    "LaRue County, Kentucky",
    "Las Animas County, Colorado",
    "LaSalle County, Illinois",
    "LaSalle Parish, Louisiana",
    "Lassen County, California",
    "Latah County, Idaho",
    "Latimer County, Oklahoma",
    "Lauderdale County, Alabama",
    "Lauderdale County, Mississippi",
    "Lauderdale County, Tennessee",
    "Laurel County, Kentucky",
    "Laurens County, Georgia",
    "Laurens County, South Carolina",
    "Lavaca County, Texas",
    "Lawrence County, Alabama",
    "Lawrence County, Arkansas",
    "Lawrence County, Illinois",
    "Lawrence County, Indiana",
    "Lawrence County, Kentucky",
    "Lawrence County, Missouri",
    "Lawrence County, Ohio",
    "Lawrence County, Pennsylvania",
    "Lawrence County, South Dakota",
    "Lawrence County, Tennessee",
    "Le Flore County, Oklahoma",
    "Le Sueur County, Minnesota",
    "Lea County, New Mexico",
    "Leake County, Mississippi",
    "Leavenworth County, Kansas",
    "Lee County, Alabama",
    "Lee County, Arkansas",
    "Lee County, Florida",
    "Lee County, Georgia",
    "Lee County, Illinois",
    "Lee County, Iowa",
    "Lee County, Kentucky",
    "Lee County, Mississippi",
    "Lee County, North Carolina",
    "Lee County, South Carolina",
    "Lee County, Texas",
    "Lee County, Virginia",
    "Leelanau County, Michigan",
    "Leflore County, Mississippi",
    "Lehigh County, Pennsylvania",
    "Lemhi County, Idaho",
    "Lenawee County, Michigan",
    "Lenoir County, North Carolina",
    "Leon County, Florida",
    "Leon County, Texas",
    "Leslie County, Kentucky",
    "Letcher County, Kentucky",
    "Levy County, Florida",
    "Lewis and Clark County, Montana",
    "Lewis County, Idaho",
    "Lewis County, Kentucky",
    "Lewis County, Missouri",
    "Lewis County, New York",
    "Lewis County, Tennessee",
    "Lewis County, Washington",
    "Lewis County, West Virginia",
    "Lexington County, South Carolina",
    "Liberty County, Florida",
    "Liberty County, Georgia",
    "Liberty County, Montana",
    "Liberty County, Texas",
    "Licking County, Ohio",
    "Limestone County, Alabama",
    "Limestone County, Texas",
    "Lincoln County, Arkansas",
    "Lincoln County, Colorado",
    "Lincoln County, Georgia",
    "Lincoln County, Idaho",
    "Lincoln County, Kansas",
    "Lincoln County, Kentucky",
    "Lincoln Parish, Louisiana",
    "Lincoln County, Maine",
    "Lincoln County, Minnesota",
    "Lincoln County, Mississippi",
    "Lincoln County, Missouri",
    "Lincoln County, Montana",
    "Lincoln County, Nebraska",
    "Lincoln County, Nevada",
    "Lincoln County, New Mexico",
    "Lincoln County, North Carolina",
    "Lincoln County, Oklahoma",
    "Lincoln County, Oregon",
    "Lincoln County, South Dakota",
    "Lincoln County, Tennessee",
    "Lincoln County, Washington",
    "Lincoln County, Wisconsin",
    "Lincoln County, Wyoming",
    "Linn County, Iowa",
    "Linn County, Kansas",
    "Linn County, Missouri",
    "Linn County, Oregon",
    "Lipscomb County, Texas",
    "Little River County, Arkansas",
    "Live Oak County, Texas",
    "Livingston County, Illinois",
    "Livingston County, Kentucky",
    "Livingston Parish, Louisiana",
    "Livingston County, Michigan",
    "Livingston County, Missouri",
    "Livingston County, New York",
    "Llano County, Texas",
    "Logan County, Arkansas",
    "Logan County, Colorado",
    "Logan County, Illinois",
    "Logan County, Kansas",
    "Logan County, Kentucky",
    "Logan County, Nebraska",
    "Logan County, North Dakota",
    "Logan County, Ohio",
    "Logan County, Oklahoma",
    "Logan County, West Virginia",
    "Long County, Georgia",
    "Lonoke County, Arkansas",
    "Lorain County, Ohio",
    "Los Alamos County, New Mexico",
    "Los Angeles County, California",
    "Loudon County, Tennessee",
    "Loudoun County, Virginia",
    "Louisa County, Iowa",
    "Louisa County, Virginia",
    "Loup County, Nebraska",
    "Love County, Oklahoma",
    "Loving County, Texas",
    "Lowndes County, Alabama",
    "Lowndes County, Georgia",
    "Lowndes County, Mississippi",
    "Lubbock County, Texas",
    "Lucas County, Iowa",
    "Lucas County, Ohio",
    "Luce County, Michigan",
    "Lumpkin County, Georgia",
    "Luna County, New Mexico",
    "Lunenburg County, Virginia",
    "Luzerne County, Pennsylvania",
    "Lycoming County, Pennsylvania",
    "Lyman County, South Dakota",
    "Lynn County, Texas",
    "Lyon County, Iowa",
    "Lyon County, Kansas",
    "Lyon County, Kentucky",
    "Lyon County, Minnesota",
    "Lyon County, Nevada",
    "Mackinac County, Michigan",
    "Macomb County, Michigan",
    "Macon County, Alabama",
    "Macon County, Georgia",
    "Macon County, Illinois",
    "Macon County, Missouri",
    "Macon County, North Carolina",
    "Macon County, Tennessee",
    "Macoupin County, Illinois",
    "Madera County, California",
    "Madison County, Alabama",
    "Madison County, Arkansas",
    "Madison County, Florida",
    "Madison County, Georgia",
    "Madison County, Idaho",
    "Madison County, Illinois",
    "Madison County, Indiana",
    "Madison County, Iowa",
    "Madison County, Kentucky",
    "Madison Parish, Louisiana",
    "Madison County, Mississippi",
    "Madison County, Missouri",
    "Madison County, Montana",
    "Madison County, Nebraska",
    "Madison County, New York",
    "Madison County, North Carolina",
    "Madison County, Ohio",
    "Madison County, Tennessee",
    "Madison County, Texas",
    "Madison County, Virginia",
    "Magoffin County, Kentucky",
    "Mahaska County, Iowa",
    "Mahnomen County, Minnesota",
    "Mahoning County, Ohio",
    "Major County, Oklahoma",
    "Malheur County, Oregon",
    "Manatee County, Florida",
    "Manistee County, Michigan",
    "Manitowoc County, Wisconsin",
    "Marathon County, Wisconsin",
    "Marengo County, Alabama",
    "Maricopa County, Arizona",
    "Maries County, Missouri",
    "Marin County, California",
    "Marinette County, Wisconsin",
    "Marion County, Alabama",
    "Marion County, Arkansas",
    "Marion County, Florida",
    "Marion County, Georgia",
    "Marion County, Illinois",
    "Marion County, Iowa",
    "Marion County, Kansas",
    "Marion County, Kentucky",
    "Marion County, Mississippi",
    "Marion County, Missouri",
    "Marion County, Ohio",
    "Marion County, Oregon",
    "Marion County, South Carolina",
    "Marion County, Tennessee",
    "Marion County, Texas",
    "Marion County, West Virginia",
    "Mariposa County, California",
    "Marlboro County, South Carolina",
    "Marquette County, Michigan",
    "Marquette County, Wisconsin",
    "Marshall County, Alabama",
    "Marshall County, Illinois",
    "Marshall County, Indiana",
    "Marshall County, Iowa",
    "Marshall County, Kansas",
    "Marshall County, Kentucky",
    "Marshall County, Minnesota",
    "Marshall County, Mississippi",
    "Marshall County, Oklahoma",
    "Marshall County, South Dakota",
    "Marshall County, Tennessee",
    "Marshall County, West Virginia",
    "Martin County, Florida",
    "Martin County, Indiana",
    "Martin County, Kentucky",
    "Martin County, Minnesota",
    "Martin County, North Carolina",
    "Martin County, Texas",
    "Mason County, Illinois",
    "Mason County, Kentucky",
    "Mason County, Michigan",
    "Mason County, Texas",
    "Mason County, Washington",
    "Mason County, West Virginia",
    "Massac County, Illinois",
    "Matagorda County, Texas",
    "Mathews County, Virginia",
    "Maui County, Hawaii",
    "Maury County, Tennessee",
    "Maverick County, Texas",
    "Mayes County, Oklahoma",
    "McClain County, Oklahoma",
    "McCone County, Montana",
    "McCook County, South Dakota",
    "McCormick County, South Carolina",
    "McCracken County, Kentucky",
    "McCreary County, Kentucky",
    "McCulloch County, Texas",
    "McCurtain County, Oklahoma",
    "McDonald County, Missouri",
    "McDonough County, Illinois",
    "McDowell County, North Carolina",
    "McDowell County, West Virginia",
    "McDuffie County, Georgia",
    "McHenry County, Illinois",
    "McHenry County, North Dakota",
    "McIntosh County, Georgia",
    "McIntosh County, North Dakota",
    "McIntosh County, Oklahoma",
    "McKean County, Pennsylvania",
    "McKenzie County, North Dakota",
    "McKinley County, New Mexico",
    "McLean County, Illinois",
    "McLean County, Kentucky",
    "McLean County, North Dakota",
    "McLennan County, Texas",
    "McLeod County, Minnesota",
    "McMinn County, Tennessee",
    "McMullen County, Texas",
    "McNairy County, Tennessee",
    "McPherson County, Kansas",
    "McPherson County, Nebraska",
    "McPherson County, South Dakota",
    "Meade County, Kansas",
    "Meade County, Kentucky",
    "Meade County, South Dakota",
    "Meagher County, Montana",
    "Mecklenburg County, Virginia",
    "Mecosta County, Michigan",
    "Medina County, Ohio",
    "Medina County, Texas",
    "Meeker County, Minnesota",
    "Meigs County, Ohio",
    "Meigs County, Tennessee",
    "Mellette County, South Dakota",
    "Menard County, Illinois",
    "Menard County, Texas",
    "Mendocino County, California",
    "Menifee County, Kentucky",
    "Menominee County, Michigan",
    "Menominee County, Wisconsin",
    "Merced County, California",
    "Mercer County, Illinois",
    "Mercer County, Kentucky",
    "Mercer County, Missouri",
    "Mercer County, New Jersey",
    "Mercer County, North Dakota",
    "Mercer County, Ohio",
    "Mercer County, Pennsylvania",
    "Mercer County, West Virginia",
    "Meriwether County, Georgia",
    "Merrick County, Nebraska",
    "Merrimack County, New Hampshire",
    "Mesa County, Colorado",
    "Metcalfe County, Kentucky",
    "Miami County, Indiana",
    "Miami County, Kansas",
    "Miami County, Ohio",
    "Miami-Dade County, Florida",
    "Middlesex County, New Jersey",
    "Middlesex County, Virginia",
    "Midland County, Michigan",
    "Midland County, Texas",
    "Mifflin County, Pennsylvania",
    "Milam County, Texas",
    "Millard County, Utah",
    "Mille Lacs County, Minnesota",
    "Miller County, Arkansas",
    "Miller County, Georgia",
    "Miller County, Missouri",
    "Mills County, Iowa",
    "Mills County, Texas",
    "Milwaukee County, Wisconsin",
    "Miner County, South Dakota",
    "Mineral County, Colorado",
    "Mineral County, Montana",
    "Mineral County, Nevada",
    "Mineral County, West Virginia",
    "Mingo County, West Virginia",
    "Minidoka County, Idaho",
    "Minnehaha County, South Dakota",
    "Missaukee County, Michigan",
    "Mississippi County, Arkansas",
    "Mississippi County, Missouri",
    "Missoula County, Montana",
    "Mitchell County, Georgia",
    "Mitchell County, Iowa",
    "Mitchell County, Kansas",
    "Mitchell County, North Carolina",
    "Mitchell County, Texas",
    "Mobile County, Alabama",
    "Modoc County, California",
    "Moffat County, Colorado",
    "Mohave County, Arizona",
    "Moniteau County, Missouri",
    "Monmouth County, New Jersey",
    "Mono County, California",
    "Monona County, Iowa",
    "Monongalia County, West Virginia",
    "Monroe County, Alabama",
    "Monroe County, Arkansas",
    "Monroe County, Florida",
    "Monroe County, Georgia",
    "Monroe County, Illinois",
    "Monroe County, Indiana",
    "Monroe County, Iowa",
    "Monroe County, Kentucky",
    "Monroe County, Michigan",
    "Monroe County, Mississippi",
    "Monroe County, Missouri",
    "Monroe County, New York",
    "Monroe County, Ohio",
    "Monroe County, Pennsylvania",
    "Monroe County, Tennessee",
    "Monroe County, West Virginia",
    "Monroe County, Wisconsin",
    "Montague County, Texas",
    "Montcalm County, Michigan",
    "Monterey County, California",
    "Montezuma County, Colorado",
    "Montgomery County, Alabama",
    "Montgomery County, Arkansas",
    "Montgomery County, Georgia",
    "Montgomery County, Illinois",
    "Montgomery County, Indiana",
    "Montgomery County, Kansas",
    "Montgomery County, Kentucky",
    "Montgomery County, Maryland",
    "Montgomery County, Missouri",
    "Montgomery County, New York",
    "Montgomery County, North Carolina",
    "Montgomery County, Ohio",
    "Montgomery County, Pennsylvania",
    "Montgomery County, Tennessee",
    "Montgomery County, Texas",
    "Montgomery County, Virginia",
    "Montmorency County, Michigan",
    "Montour County, Pennsylvania",
    "Montrose County, Colorado",
    "Moody County, South Dakota",
    "Moore County, North Carolina",
    "Moore County, Tennessee",
    "Moore County, Texas",
    "Mora County, New Mexico",
    "Morehouse Parish, Louisiana",
    "Morgan County, Alabama",
    "Morgan County, Colorado",
    "Morgan County, Georgia",
    "Morgan County, Illinois",
    "Morgan County, Kentucky",
    "Morgan County, Missouri",
    "Morgan County, Ohio",
    "Morgan County, Tennessee",
    "Morgan County, Utah",
    "Morgan County, West Virginia",
    "Morrill County, Nebraska",
    "Morris County, Kansas",
    "Morris County, New Jersey",
    "Morris County, Texas",
    "Morrison County, Minnesota",
    "Morrow County, Ohio",
    "Morrow County, Oregon",
    "Morton County, Kansas",
    "Morton County, North Dakota",
    "Motley County, Texas",
    "Moultrie County, Illinois",
    "Mountrail County, North Dakota",
    "Mower County, Minnesota",
    "Muhlenberg County, Kentucky",
    "Multnomah County, Oregon",
    "Murray County, Georgia",
    "Murray County, Minnesota",
    "Murray County, Oklahoma",
    "Muscatine County, Iowa",
    "Muscogee County, Georgia",
    "Muskegon County, Michigan",
    "Muskingum County, Ohio",
    "Muskogee County, Oklahoma",
    "Musselshell County, Montana",
    "Nacogdoches County, Texas",
    "Nance County, Nebraska",
    "Napa County, California",
    "Nash County, North Carolina",
    "Nassau County, Florida",
    "Nassau County, New York",
    "Natchitoches Parish, Louisiana",
    "Natrona County, Wyoming",
    "Navajo County, Arizona",
    "Navarro County, Texas",
    "Nelson County, Kentucky",
    "Nelson County, North Dakota",
    "Nelson County, Virginia",
    "Nemaha County, Kansas",
    "Nemaha County, Nebraska",
    "Neosho County, Kansas",
    "Neshoba County, Mississippi",
    "Ness County, Kansas",
    "Nevada County, Arkansas",
    "Nevada County, California",
    "New Castle County, Delaware",
    "New Hanover County, North Carolina",
    "New Kent County, Virginia",
    "New Madrid County, Missouri",
    "Newaygo County, Michigan",
    "Newberry County, South Carolina",
    "Newport County, Rhode Island",
    "Newton County, Arkansas",
    "Newton County, Georgia",
    "Newton County, Indiana",
    "Newton County, Missouri",
    "Newton County, Texas",
    "Nez Perce County, Idaho",
    "Niagara County, New York",
    "Nicholas County, Kentucky",
    "Nicholas County, West Virginia",
    "Nicollet County, Minnesota",
    "Niobrara County, Wyoming",
    "Noble County, Indiana",
    "Noble County, Ohio",
    "Noble County, Oklahoma",
    "Nobles County, Minnesota",
    "Nodaway County, Missouri",
    "Nolan County, Texas",
    "Norman County, Minnesota",
    "North Slope Borough, Alaska",
    "Northampton County, North Carolina",
    "Northampton County, Pennsylvania",
    "Northampton County, Virginia",
    "Northumberland County, Pennsylvania",
    "Northumberland County, Virginia",
    "Norton County, Kansas",
    "Nottoway County, Virginia",
    "Nowata County, Oklahoma",
    "Noxubee County, Mississippi",
    "Nuckolls County, Nebraska",
    "Nueces County, Texas",
    "Nye County, Nevada",
    "O'Brien County, Iowa",
    "Oakland County, Michigan",
    "Obion County, Tennessee",
    "Ocean County, New Jersey",
    "Oceana County, Michigan",
    "Ochiltree County, Texas",
    "Oconee County, Georgia",
    "Oconee County, South Carolina",
    "Oconto County, Wisconsin",
    "Ogemaw County, Michigan",
    "Oglala Lakota County, South Dakota",
    "Ogle County, Illinois",
    "Oglethorpe County, Georgia",
    "Ohio County, Kentucky",
    "Ohio County, West Virginia",
    "Okaloosa County, Florida",
    "Okanogan County, Washington",
    "Okeechobee County, Florida",
    "Okfuskee County, Oklahoma",
    "Oklahoma County, Oklahoma",
    "Okmulgee County, Oklahoma",
    "Oktibbeha County, Mississippi",
    "Oldham County, Kentucky",
    "Oldham County, Texas",
    "Oliver County, North Dakota",
    "Olmsted County, Minnesota",
    "Oneida County, Idaho",
    "Oneida County, New York",
    "Oneida County, Wisconsin",
    "Onondaga County, New York",
    "Onslow County, North Carolina",
    "Ontario County, New York",
    "Ontonagon County, Michigan",
    "Orange County, California",
    "Orange County, Florida",
    "Orange County, Indiana",
    "Orange County, New York",
    "Orange County, North Carolina",
    "Orange County, Texas",
    "Orange County, Vermont",
    "Orange County, Virginia",
    "Orangeburg County, South Carolina",
    "Oregon County, Missouri",
    "Orleans County, New York",
    "Orleans County, Vermont",
    "Osage County, Kansas",
    "Osage County, Missouri",
    "Osage County, Oklahoma",
    "Osborne County, Kansas",
    "Osceola County, Florida",
    "Osceola County, Iowa",
    "Osceola County, Michigan",
    "Oscoda County, Michigan",
    "Oswego County, New York",
    "Otero County, Colorado",
    "Otero County, New Mexico",
    "Otoe County, Nebraska",
    "Otsego County, Michigan",
    "Otsego County, New York",
    "Ottawa County, Kansas",
    "Ottawa County, Michigan",
    "Ottawa County, Ohio",
    "Ottawa County, Oklahoma",
    "Otter Tail County, Minnesota",
    "Ouachita County, Arkansas",
    "Ouachita Parish, Louisiana",
    "Ouray County, Colorado",
    "Outagamie County, Wisconsin",
    "Overton County, Tennessee",
    "Owen County, Indiana",
    "Owen County, Kentucky",
    "Owsley County, Kentucky",
    "Owyhee County, Idaho",
    "Oxford County, Maine",
    "Ozark County, Missouri",
    "Ozaukee County, Wisconsin",
    "Pacific County, Washington",
    "Page County, Iowa",
    "Page County, Virginia",
    "Palm Beach County, Florida",
    "Palo Alto County, Iowa",
    "Palo Pinto County, Texas",
    "Pamlico County, North Carolina",
    "Panola County, Mississippi",
    "Panola County, Texas",
    "Park County, Colorado",
    "Park County, Montana",
    "Park County, Wyoming",
    "Parke County, Indiana",
    "Parker County, Texas",
    "Parmer County, Texas",
    "Pasco County, Florida",
    "Pasquotank County, North Carolina",
    "Passaic County, New Jersey",
    "Patrick County, Virginia",
    "Paulding County, Georgia",
    "Paulding County, Ohio",
    "Pawnee County, Kansas",
    "Pawnee County, Nebraska",
    "Pawnee County, Oklahoma",
    "Payette County, Idaho",
    "Payne County, Oklahoma",
    "Peach County, Georgia",
    "Pearl River County, Mississippi",
    "Pecos County, Texas",
    "Pembina County, North Dakota",
    "Pemiscot County, Missouri",
    "Pend Oreille County, Washington",
    "Pender County, North Carolina",
    "Pendleton County, Kentucky",
    "Pendleton County, West Virginia",
    "Pennington County, Minnesota",
    "Pennington County, South Dakota",
    "Penobscot County, Maine",
    "Peoria County, Illinois",
    "Pepin County, Wisconsin",
    "Perkins County, Nebraska",
    "Perkins County, South Dakota",
    "Perquimans County, North Carolina",
    "Perry County, Alabama",
    "Perry County, Arkansas",
    "Perry County, Illinois",
    "Perry County, Indiana",
    "Perry County, Kentucky",
    "Perry County, Missouri",
    "Perry County, Ohio",
    "Perry County, Tennessee",
    "Pershing County, Nevada",
    "Person County, North Carolina",
    "Petroleum County, Montana",
    "Pettis County, Missouri",
    "Phelps County, Missouri",
    "Phelps County, Nebraska",
    "Phillips County, Arkansas",
    "Phillips County, Colorado",
    "Phillips County, Kansas",
    "Phillips County, Montana",
    "Piatt County, Illinois",
    "Pickaway County, Ohio",
    "Pickens County, Alabama",
    "Pickens County, Georgia",
    "Pickens County, South Carolina",
    "Pickett County, Tennessee",
    "Pierce County, Georgia",
    "Pierce County, Nebraska",
    "Pierce County, North Dakota",
    "Pierce County, Washington",
    "Pierce County, Wisconsin",
    "Pike County, Alabama",
    "Pike County, Arkansas",
    "Pike County, Georgia",
    "Pike County, Illinois",
    "Pike County, Indiana",
    "Pike County, Kentucky",
    "Pike County, Mississippi",
    "Pike County, Missouri",
    "Pike County, Ohio",
    "Pike County, Pennsylvania",
    "Pima County, Arizona",
    "Pinal County, Arizona",
    "Pine County, Minnesota",
    "Pinellas County, Florida",
    "Pipestone County, Minnesota",
    "Piscataquis County, Maine",
    "Pitkin County, Colorado",
    "Pitt County, North Carolina",
    "Pittsburg County, Oklahoma",
    "Pittsylvania County, Virginia",
    "Piute County, Utah",
    "Placer County, California",
    "Plaquemines Parish, Louisiana",
    "Platte County, Missouri",
    "Platte County, Nebraska",
    "Platte County, Wyoming",
    "Pleasants County, West Virginia",
    "Plumas County, California",
    "Plymouth County, Iowa",
    "Pocahontas County, Iowa",
    "Pocahontas County, West Virginia",
    "Poinsett County, Arkansas",
    "Pointe Coupee Parish, Louisiana",
    "Polk County, Arkansas",
    "Polk County, Florida",
    "Polk County, Georgia",
    "Polk County, Iowa",
    "Polk County, Minnesota",
    "Polk County, Missouri",
    "Polk County, Nebraska",
    "Polk County, North Carolina",
    "Polk County, Oregon",
    "Polk County, Tennessee",
    "Polk County, Texas",
    "Polk County, Wisconsin",
    "Pondera County, Montana",
    "Pontotoc County, Mississippi",
    "Pontotoc County, Oklahoma",
    "Pope County, Arkansas",
    "Pope County, Illinois",
    "Pope County, Minnesota",
    "Portage County, Ohio",
    "Portage County, Wisconsin",
    "Porter County, Indiana",
    "Posey County, Indiana",
    "Pottawatomie County, Kansas",
    "Pottawatomie County, Oklahoma",
    "Pottawattamie County, Iowa",
    "Potter County, Pennsylvania",
    "Potter County, South Dakota",
    "Potter County, Texas",
    "Powder River County, Montana",
    "Powell County, Kentucky",
    "Powell County, Montana",
    "Power County, Idaho",
    "Poweshiek County, Iowa",
    "Powhatan County, Virginia",
    "Prairie County, Arkansas",
    "Prairie County, Montana",
    "Pratt County, Kansas",
    "Preble County, Ohio",
    "Prentiss County, Mississippi",
    "Presidio County, Texas",
    "Presque Isle County, Michigan",
    "Preston County, West Virginia",
    "Price County, Wisconsin",
    "Prince Edward County, Virginia",
    "Prince George County, Virginia",
    "Prince George's County, Maryland",
    "Prince William County, Virginia",
    "Prowers County, Colorado",
    "Pueblo County, Colorado",
    "Pulaski County, Arkansas",
    "Pulaski County, Georgia",
    "Pulaski County, Illinois",
    "Pulaski County, Indiana",
    "Pulaski County, Kentucky",
    "Pulaski County, Missouri",
    "Pulaski County, Virginia",
    "Pushmataha County, Oklahoma",
    "Putnam County, Florida",
    "Putnam County, Georgia",
    "Putnam County, Illinois",
    "Putnam County, Indiana",
    "Putnam County, Missouri",
    "Putnam County, New York",
    "Putnam County, Ohio",
    "Putnam County, Tennessee",
    "Putnam County, West Virginia",
    "Quay County, New Mexico",
    "Queen Anne's County, Maryland",
    "Quitman County, Georgia",
    "Rabun County, Georgia",
    "Racine County, Wisconsin",
    "Rains County, Texas",
    "Raleigh County, West Virginia",
    "Ralls County, Missouri",
    "Ramsey County, Minnesota",
    "Ramsey County, North Dakota",
    "Randall County, Texas",
    "Randolph County, Alabama",
    "Randolph County, Arkansas",
    "Randolph County, Georgia",
    "Randolph County, Illinois",
    "Randolph County, Indiana",
    "Randolph County, Missouri",
    "Randolph County, North Carolina",
    "Randolph County, West Virginia",
    "Rankin County, Mississippi",
    "Ransom County, North Dakota",
    "Rapides Parish, Louisiana",
    "Rappahannock County, Virginia",
    "Ravalli County, Montana",
    "Rawlins County, Kansas",
    "Ray County, Missouri",
    "Reagan County, Texas",
    "Real County, Texas",
    "Red Lake County, Minnesota",
    "Red River Parish, Louisiana",
    "Red River County, Texas",
    "Red Willow County, Nebraska",
    "Redwood County, Minnesota",
    "Reeves County, Texas",
    "Refugio County, Texas",
    "Reno County, Kansas",
    "Rensselaer County, New York",
    "Renville County, Minnesota",
    "Renville County, North Dakota",
    "Republic County, Kansas",
    "Reynolds County, Missouri",
    "Rhea County, Tennessee",
    "Rice County, Kansas",
    "Rice County, Minnesota",
    "Rich County, Utah",
    "Richardson County, Nebraska",
    "Richland County, Illinois",
    "Richland Parish, Louisiana",
    "Richland County, Montana",
    "Richland County, North Dakota",
    "Richland County, Ohio",
    "Richland County, South Carolina",
    "Richland County, Wisconsin",
    "Richmond County, Georgia",
    "Richmond County, North Carolina",
    "Richmond County, Virginia",
    "Riley County, Kansas",
    "Ringgold County, Iowa",
    "Rio Arriba County, New Mexico",
    "Rio Blanco County, Colorado",
    "Rio Grande County, Colorado",
    "Ripley County, Indiana",
    "Ripley County, Missouri",
    "Ritchie County, West Virginia",
    "Riverside County, California",
    "Roane County, Tennessee",
    "Roane County, West Virginia",
    "Roanoke County, Virginia",
    "Roberts County, South Dakota",
    "Roberts County, Texas",
    "Robertson County, Kentucky",
    "Robertson County, Tennessee",
    "Robertson County, Texas",
    "Robeson County, North Carolina",
    "Rock County, Minnesota",
    "Rock County, Nebraska",
    "Rock County, Wisconsin",
    "Rock Island County, Illinois",
    "Rockbridge County, Virginia",
    "Rockcastle County, Kentucky",
    "Rockdale County, Georgia",
    "Rockingham County, New Hampshire",
    "Rockingham County, North Carolina",
    "Rockingham County, Virginia",
    "Rockland County, New York",
    "Rockwall County, Texas",
    "Roger Mills County, Oklahoma",
    "Rogers County, Oklahoma",
    "Rolette County, North Dakota",
    "Rooks County, Kansas",
    "Roosevelt County, Montana",
    "Roosevelt County, New Mexico",
    "Roscommon County, Michigan",
    "Roseau County, Minnesota",
    "Rosebud County, Montana",
    "Ross County, Ohio",
    "Routt County, Colorado",
    "Rowan County, Kentucky",
    "Rowan County, North Carolina",
    "Runnels County, Texas",
    "Rush County, Indiana",
    "Rush County, Kansas",
    "Rusk County, Texas",
    "Rusk County, Wisconsin",
    "Russell County, Alabama",
    "Russell County, Kansas",
    "Russell County, Kentucky",
    "Russell County, Virginia",
    "Rutherford County, North Carolina",
    "Rutherford County, Tennessee",
    "Rutland County, Vermont",
    "Sabine Parish, Louisiana",
    "Sabine County, Texas",
    "Sac County, Iowa",
    "Sacramento County, California",
    "Sagadahoc County, Maine",
    "Saginaw County, Michigan",
    "Saguache County, Colorado",
    "Salem County, New Jersey",
    "Saline County, Arkansas",
    "Saline County, Illinois",
    "Saline County, Kansas",
    "Saline County, Missouri",
    "Saline County, Nebraska",
    "Salt Lake County, Utah",
    "Saluda County, South Carolina",
    "Sampson County, North Carolina",
    "San Augustine County, Texas",
    "San Benito County, California",
    "San Bernardino County, California",
    "San Diego County, California",
    "San Jacinto County, Texas",
    "San Joaquin County, California",
    "San Juan County, Colorado",
    "San Juan County, New Mexico",
    "San Juan County, Utah",
    "San Juan County, Washington",
    "San Luis Obispo County, California",
    "San Mateo County, California",
    "San Miguel County, Colorado",
    "San Miguel County, New Mexico",
    "San Patricio County, Texas",
    "San Saba County, Texas",
    "Sanborn County, South Dakota",
    "Sanders County, Montana",
    "Sandoval County, New Mexico",
    "Sandusky County, Ohio",
    "Sangamon County, Illinois",
    "Sanilac County, Michigan",
    "Sanpete County, Utah",
    "Santa Barbara County, California",
    "Santa Clara County, California",
    "Santa Cruz County, Arizona",
    "Santa Cruz County, California",
    "Santa Fe County, New Mexico",
    "Santa Rosa County, Florida",
    "Sarasota County, Florida",
    "Saratoga County, New York",
    "Sargent County, North Dakota",
    "Sarpy County, Nebraska",
    "Sauk County, Wisconsin",
    "Saunders County, Nebraska",
    "Sawyer County, Wisconsin",
    "Schenectady County, New York",
    "Schleicher County, Texas",
    "Schley County, Georgia",
    "Schoharie County, New York",
    "Schoolcraft County, Michigan",
    "Schuyler County, Illinois",
    "Schuyler County, Missouri",
    "Schuyler County, New York",
    "Schuylkill County, Pennsylvania",
    "Scioto County, Ohio",
    "Scotland County, Missouri",
    "Scotland County, North Carolina",
    "Scott County, Arkansas",
    "Scott County, Illinois",
    "Scott County, Indiana",
    "Scott County, Iowa",
    "Scott County, Kansas",
    "Scott County, Kentucky",
    "Scott County, Minnesota",
    "Scott County, Mississippi",
    "Scott County, Missouri",
    "Scott County, Tennessee",
    "Scott County, Virginia",
    "Scotts Bluff County, Nebraska",
    "Screven County, Georgia",
    "Scurry County, Texas",
    "Searcy County, Arkansas",
    "Sebastian County, Arkansas",
    "Sedgwick County, Colorado",
    "Sedgwick County, Kansas",
    "Seminole County, Florida",
    "Seminole County, Georgia",
    "Seminole County, Oklahoma",
    "Seneca County, New York",
    "Seneca County, Ohio",
    "Sequatchie County, Tennessee",
    "Sequoyah County, Oklahoma",
    "Sevier County, Arkansas",
    "Sevier County, Tennessee",
    "Sevier County, Utah",
    "Seward County, Kansas",
    "Seward County, Nebraska",
    "Shackelford County, Texas",
    "Shannon County, Missouri",
    "Sharkey County, Mississippi",
    "Sharp County, Arkansas",
    "Shasta County, California",
    "Shawano County, Wisconsin",
    "Shawnee County, Kansas",
    "Sheboygan County, Wisconsin",
    "Shelby County, Alabama",
    "Shelby County, Illinois",
    "Shelby County, Indiana",
    "Shelby County, Iowa",
    "Shelby County, Kentucky",
    "Shelby County, Missouri",
    "Shelby County, Ohio",
    "Shelby County, Tennessee",
    "Shelby County, Texas",
    "Shenandoah County, Virginia",
    "Sherburne County, Minnesota",
    "Sheridan County, Kansas",
    "Sheridan County, Montana",
    "Sheridan County, Nebraska",
    "Sheridan County, North Dakota",
    "Sheridan County, Wyoming",
    "Sherman County, Kansas",
    "Sherman County, Nebraska",
    "Sherman County, Oregon",
    "Sherman County, Texas",
    "Shiawassee County, Michigan",
    "Shoshone County, Idaho",
    "Sibley County, Minnesota",
    "Sierra County, California",
    "Sierra County, New Mexico",
    "Silver Bow County, Montana",
    "Simpson County, Kentucky",
    "Simpson County, Mississippi",
    "Sioux County, Iowa",
    "Sioux County, Nebraska",
    "Sioux County, North Dakota",
    "Siskiyou County, California",
    "Skagit County, Washington",
    "Skamania County, Washington",
    "Slope County, North Dakota",
    "Smith County, Kansas",
    "Smith County, Mississippi",
    "Smith County, Tennessee",
    "Smith County, Texas",
    "Smyth County, Virginia",
    "Snohomish County, Washington",
    "Snyder County, Pennsylvania",
    "Socorro County, New Mexico",
    "Solano County, California",
    "Somerset County, Maine",
    "Somerset County, Maryland",
    "Somerset County, New Jersey",
    "Somervell County, Texas",
    "Sonoma County, California",
    "Southampton County, Virginia",
    "Spalding County, Georgia",
    "Spartanburg County, South Carolina",
    "Spencer County, Kentucky",
    "Spink County, South Dakota",
    "Spokane County, Washington",
    "Spotsylvania County, Virginia",
    "St. Bernard Parish, Louisiana",
    "St. Charles Parish, Louisiana",
    "St. Charles County, Missouri",
    "St. Clair County, Alabama",
    "St. Clair County, Illinois",
    "St. Clair County, Michigan",
    "St. Clair County, Missouri",
    "St. Croix County, Wisconsin",
    "St. Francis County, Arkansas",
    "St. Francois County, Missouri",
    "St. Helena Parish, Louisiana",
    "St. James Parish, Louisiana",
    "St. John the Baptist Parish, Louisiana",
    "St. Johns County, Florida",
    "St. Joseph County, Indiana",
    "St. Joseph County, Michigan",
    "St. Landry Parish, Louisiana",
    "St. Lawrence County, New York",
    "St. Louis County, Minnesota",
    "St. Louis County, Missouri",
    "St. Lucie County, Florida",
    "St. Martin Parish, Louisiana",
    "St. Mary Parish, Louisiana",
    "St. Mary's County, Maryland",
    "St. Tammany Parish, Louisiana",
    "Stafford County, Kansas",
    "Stafford County, Virginia",
    "Stanislaus County, California",
    "Stanley County, South Dakota",
    "Stanly County, North Carolina",
    "Stanton County, Kansas",
    "Stanton County, Nebraska",
    "Stark County, Illinois",
    "Stark County, North Dakota",
    "Stark County, Ohio",
    "Starke County, Indiana",
    "Starr County, Texas",
    "Ste. Genevieve County, Missouri",
    "Stearns County, Minnesota",
    "Steele County, Minnesota",
    "Steele County, North Dakota",
    "Stephens County, Georgia",
    "Stephens County, Oklahoma",
    "Stephens County, Texas",
    "Stephenson County, Illinois",
    "Sterling County, Texas",
    "Steuben County, Indiana",
    "Steuben County, New York",
    "Stevens County, Kansas",
    "Stevens County, Minnesota",
    "Stevens County, Washington",
    "Stewart County, Georgia",
    "Stewart County, Tennessee",
    "Stillwater County, Montana",
    "Stoddard County, Missouri",
    "Stokes County, North Carolina",
    "Stone County, Arkansas",
    "Stone County, Mississippi",
    "Stone County, Missouri",
    "Stonewall County, Texas",
    "Storey County, Nevada",
    "Story County, Iowa",
    "Strafford County, New Hampshire",
    "Stutsman County, North Dakota",
    "Sublette County, Wyoming",
    "Suffolk County, New York",
    "Sullivan County, Indiana",
    "Sullivan County, Missouri",
    "Sullivan County, New Hampshire",
    "Sullivan County, New York",
    "Sullivan County, Pennsylvania",
    "Sullivan County, Tennessee",
    "Sully County, South Dakota",
    "Summers County, West Virginia",
    "Summit County, Colorado",
    "Summit County, Ohio",
    "Summit County, Utah",
    "Sumner County, Kansas",
    "Sumner County, Tennessee",
    "Sumter County, Alabama",
    "Sumter County, Florida",
    "Sumter County, Georgia",
    "Sumter County, South Carolina",
    "Sunflower County, Mississippi",
    "Surry County, North Carolina",
    "Surry County, Virginia",
    "Sussex County, New Jersey",
    "Sussex County, Virginia",
    "Sutter County, California",
    "Sutton County, Texas",
    "Suwannee County, Florida",
    "Swain County, North Carolina",
    "Sweet Grass County, Montana",
    "Sweetwater County, Wyoming",
    "Swift County, Minnesota",
    "Swisher County, Texas",
    "Talbot County, Georgia",
    "Talbot County, Maryland",
    "Taliaferro County, Georgia",
    "Talladega County, Alabama",
    "Tallahatchie County, Mississippi",
    "Tallapoosa County, Alabama",
    "Tama County, Iowa",
    "Taney County, Missouri",
    "Tangipahoa Parish, Louisiana",
    "Taos County, New Mexico",
    "Tarrant County, Texas",
    "Tate County, Mississippi",
    "Tattnall County, Georgia",
    "Taylor County, Florida",
    "Taylor County, Georgia",
    "Taylor County, Iowa",
    "Taylor County, Kentucky",
    "Taylor County, Texas",
    "Taylor County, West Virginia",
    "Taylor County, Wisconsin",
    "Tazewell County, Illinois",
    "Tazewell County, Virginia",
    "Tehama County, California",
    "Telfair County, Georgia",
    "Teller County, Colorado",
    "Tensas Parish, Louisiana",
    "Terrebonne Parish, Louisiana",
    "Terrell County, Georgia",
    "Terrell County, Texas",
    "Terry County, Texas",
    "Teton County, Idaho",
    "Teton County, Montana",
    "Teton County, Wyoming",
    "Texas County, Missouri",
    "Texas County, Oklahoma",
    "Thayer County, Nebraska",
    "Thomas County, Georgia",
    "Thomas County, Kansas",
    "Thomas County, Nebraska",
    "Throckmorton County, Texas",
    "Thurston County, Nebraska",
    "Thurston County, Washington",
    "Tift County, Georgia",
    "Tillamook County, Oregon",
    "Tillman County, Oklahoma",
    "Tioga County, New York",
    "Tioga County, Pennsylvania",
    "Tippah County, Mississippi",
    "Tippecanoe County, Indiana",
    "Tipton County, Indiana",
    "Tipton County, Tennessee",
    "Tishomingo County, Mississippi",
    "Titus County, Texas",
    "Todd County, Kentucky",
    "Todd County, Minnesota",
    "Todd County, South Dakota",
    "Tom Green County, Texas",
    "Tompkins County, New York",
    "Tooele County, Utah",
    "Toole County, Montana",
    "Toombs County, Georgia",
    "Torrance County, New Mexico",
    "Towner County, North Dakota",
    "Towns County, Georgia",
    "Traill County, North Dakota",
    "Transylvania County, North Carolina",
    "Traverse County, Minnesota",
    "Travis County, Texas",
    "Treasure County, Montana",
    "Trego County, Kansas",
    "Trempealeau County, Wisconsin",
    "Treutlen County, Georgia",
    "Trigg County, Kentucky",
    "Trimble County, Kentucky",
    "Trinity County, California",
    "Trinity County, Texas",
    "Tripp County, South Dakota",
    "Troup County, Georgia",
    "Trousdale County, Tennessee",
    "Trumbull County, Ohio",
    "Tucker County, West Virginia",
    "Tulare County, California",
    "Tulsa County, Oklahoma",
    "Tunica County, Mississippi",
    "Tuolumne County, California",
    "Turner County, Georgia",
    "Turner County, South Dakota",
    "Tuscaloosa County, Alabama",
    "Tuscarawas County, Ohio",
    "Tuscola County, Michigan",
    "Twiggs County, Georgia",
    "Twin Falls County, Idaho",
    "Tyler County, Texas",
    "Tyler County, West Virginia",
    "Tyrrell County, North Carolina",
    "Uinta County, Wyoming",
    "Uintah County, Utah",
    "Ulster County, New York",
    "Umatilla County, Oregon",
    "Unicoi County, Tennessee",
    "Union County, Arkansas",
    "Union County, Florida",
    "Union County, Georgia",
    "Union County, Illinois",
    "Union County, Indiana",
    "Union County, Iowa",
    "Union County, Kentucky",
    "Union Parish, Louisiana",
    "Union County, Mississippi",
    "Union County, New Jersey",
    "Union County, New Mexico",
    "Union County, North Carolina",
    "Union County, Ohio",
    "Union County, Oregon",
    "Union County, Pennsylvania",
    "Union County, South Carolina",
    "Union County, South Dakota",
    "Union County, Tennessee",
    "Upshur County, Texas",
    "Upshur County, West Virginia",
    "Upson County, Georgia",
    "Upton County, Texas",
    "Utah County, Utah",
    "Uvalde County, Texas",
    "Val Verde County, Texas",
    "Valencia County, New Mexico",
    "Valley County, Idaho",
    "Valley County, Montana",
    "Valley County, Nebraska",
    "Van Buren County, Arkansas",
    "Van Buren County, Iowa",
    "Van Buren County, Michigan",
    "Van Buren County, Tennessee",
    "Van Wert County, Ohio",
    "Van Zandt County, Texas",
    "Vance County, North Carolina",
    "Vanderburgh County, Indiana",
    "Ventura County, California",
    "Vermilion County, Illinois",
    "Vermilion Parish, Louisiana",
    "Vermillion County, Indiana",
    "Vernon Parish, Louisiana",
    "Vernon County, Missouri",
    "Vernon County, Wisconsin",
    "Victoria County, Texas",
    "Vigo County, Indiana",
    "Vilas County, Wisconsin",
    "Vinton County, Ohio",
    "Volusia County, Florida",
    "Wabash County, Illinois",
    "Wabash County, Indiana",
    "Wabasha County, Minnesota",
    "Wabaunsee County, Kansas",
    "Wadena County, Minnesota",
    "Wagoner County, Oklahoma",
    "Wahkiakum County, Washington",
    "Wake County, North Carolina",
    "Wakulla County, Florida",
    "Waldo County, Maine",
    "Walker County, Alabama",
    "Walker County, Georgia",
    "Walker County, Texas",
    "Walla Walla County, Washington",
    "Waller County, Texas",
    "Wallowa County, Oregon",
    "Walsh County, North Dakota",
    "Walthall County, Mississippi",
    "Walton County, Florida",
    "Walton County, Georgia",
    "Walworth County, South Dakota",
    "Walworth County, Wisconsin",
    "Wapello County, Iowa",
    "Ward County, North Dakota",
    "Ward County, Texas",
    "Ware County, Georgia",
    "Warren County, Georgia",
    "Warren County, Illinois",
    "Warren County, Iowa",
    "Warren County, Kentucky",
    "Warren County, Mississippi",
    "Warren County, Missouri",
    "Warren County, New Jersey",
    "Warren County, New York",
    "Warren County, North Carolina",
    "Warren County, Ohio",
    "Warren County, Pennsylvania",
    "Warren County, Tennessee",
    "Warren County, Virginia",
    "Warrick County, Indiana",
    "Wasatch County, Utah",
    "Wasco County, Oregon",
    "Waseca County, Minnesota",
    "Washakie County, Wyoming",
    "Washburn County, Wisconsin",
    "Washington County, Alabama",
    "Washington County, Arkansas",
    "Washington County, Colorado",
    "Washington County, Florida",
    "Washington County, Georgia",
    "Washington County, Idaho",
    "Washington County, Illinois",
    "Washington County, Indiana",
    "Washington County, Iowa",
    "Washington County, Kansas",
    "Washington County, Kentucky",
    "Washington Parish, Louisiana",
    "Washington County, Maine",
    "Washington County, Maryland",
    "Washington County, Minnesota",
    "Washington County, Mississippi",
    "Washington County, Missouri",
    "Washington County, Nebraska",
    "Washington County, New York",
    "Washington County, North Carolina",
    "Washington County, Ohio",
    "Washington County, Oklahoma",
    "Washington County, Oregon",
    "Washington County, Pennsylvania",
    "Washington County, Tennessee",
    "Washington County, Texas",
    "Washington County, Utah",
    "Washington County, Vermont",
    "Washington County, Virginia",
    "Washington County, Wisconsin",
    "Washita County, Oklahoma",
    "Washoe County, Nevada",
    "Washtenaw County, Michigan",
    "Watauga County, North Carolina",
    "Watonwan County, Minnesota",
    "Waukesha County, Wisconsin",
    "Waupaca County, Wisconsin",
    "Waushara County, Wisconsin",
    "Wayne County, Georgia",
    "Wayne County, Illinois",
    "Wayne County, Indiana",
    "Wayne County, Iowa",
    "Wayne County, Kentucky",
    "Wayne County, Michigan",
    "Wayne County, Mississippi",
    "Wayne County, Missouri",
    "Wayne County, Nebraska",
    "Wayne County, New York",
    "Wayne County, North Carolina",
    "Wayne County, Ohio",
    "Wayne County, Pennsylvania",
    "Wayne County, Tennessee",
    "Wayne County, Utah",
    "Wayne County, West Virginia",
    "Weakley County, Tennessee",
    "Webb County, Texas",
    "Weber County, Utah",
    "Webster County, Georgia",
    "Webster County, Iowa",
    "Webster County, Kentucky",
    "Webster Parish, Louisiana",
    "Webster County, Mississippi",
    "Webster County, Missouri",
    "Webster County, Nebraska",
    "Webster County, West Virginia",
    "Weld County, Colorado",
    "Wells County, Indiana",
    "Wells County, North Dakota",
    "West Baton Rouge Parish, Louisiana",
    "West Carroll Parish, Louisiana",
    "West Feliciana Parish, Louisiana",
    "Westchester County, New York",
    "Westmoreland County, Pennsylvania",
    "Westmoreland County, Virginia",
    "Weston County, Wyoming",
    "Wetzel County, West Virginia",
    "Wexford County, Michigan",
    "Wharton County, Texas",
    "Whatcom County, Washington",
    "Wheatland County, Montana",
    "Wheeler County, Georgia",
    "Wheeler County, Nebraska",
    "Wheeler County, Oregon",
    "Wheeler County, Texas",
    "White County, Arkansas",
    "White County, Georgia",
    "White County, Illinois",
    "White County, Indiana",
    "White County, Tennessee",
    "White Pine County, Nevada",
    "Whiteside County, Illinois",
    "Whitfield County, Georgia",
    "Whitley County, Indiana",
    "Whitley County, Kentucky",
    "Whitman County, Washington",
    "Wibaux County, Montana",
    "Wichita County, Kansas",
    "Wichita County, Texas",
    "Wicomico County, Maryland",
    "Wilbarger County, Texas",
    "Wilcox County, Alabama",
    "Wilcox County, Georgia",
    "Wilkes County, Georgia",
    "Wilkes County, North Carolina",
    "Wilkin County, Minnesota",
    "Wilkinson County, Georgia",
    "Will County, Illinois",
    "Willacy County, Texas",
    "Williams County, North Dakota",
    "Williams County, Ohio",
    "Williamsburg County, South Carolina",
    "Williamson County, Illinois",
    "Williamson County, Tennessee",
    "Williamson County, Texas",
    "Wilson County, Kansas",
    "Wilson County, North Carolina",
    "Wilson County, Tennessee",
    "Wilson County, Texas",
    "Windham County, Vermont",
    "Windsor County, Vermont",
    "Winkler County, Texas",
    "Winn Parish, Louisiana",
    "Winnebago County, Illinois",
    "Winnebago County, Iowa",
    "Winnebago County, Wisconsin",
    "Winneshiek County, Iowa",
    "Winona County, Minnesota",
    "Winston County, Alabama",
    "Winston County, Mississippi",
    "Wirt County, West Virginia",
    "Wise County, Texas",
    "Wise County, Virginia",
    "Wolfe County, Kentucky",
    "Wood County, Ohio",
    "Wood County, Texas",
    "Wood County, West Virginia",
    "Wood County, Wisconsin",
    "Woodbury County, Iowa",
    "Woodford County, Illinois",
    "Woodford County, Kentucky",
    "Woodruff County, Arkansas",
    "Woods County, Oklahoma",
    "Woodson County, Kansas",
    "Woodward County, Oklahoma",
    "Worcester County, Maryland",
    "Worth County, Georgia",
    "Worth County, Iowa",
    "Worth County, Missouri",
    "Wright County, Iowa",
    "Wright County, Minnesota",
    "Wright County, Missouri",
    "Wyandot County, Ohio",
    "Wyandotte County, Kansas",
    "Wyoming County, New York",
    "Wyoming County, Pennsylvania",
    "Wyoming County, West Virginia",
    "Wythe County, Virginia",
    "Yadkin County, North Carolina",
    "Yakima County, Washington",
    "Yalobusha County, Mississippi",
    "Yamhill County, Oregon",
    "Yancey County, North Carolina",
    "Yankton County, South Dakota",
    "Yates County, New York",
    "Yavapai County, Arizona",
    "Yell County, Arkansas",
    "Yellow Medicine County, Minnesota",
    "Yellowstone County, Montana",
    "Yoakum County, Texas",
    "Yolo County, California",
    "York County, Maine",
    "York County, Nebraska",
    "York County, Pennsylvania",
    "York County, South Carolina",
    "York County, Virginia",
    "Young County, Texas",
    "Yuba County, California",
    "Yuma County, Arizona",
    "Yuma County, Colorado",
    "Zapata County, Texas",
    "Zavala County, Texas",
    "Ziebach County, South Dakota",
];